import PVRFileStream from "./PVRFileStream"




// ******************************************************************************/
// #include <string.h>
// #include <stdio.h>
// #include <stdlib.h>

// #include "PVRTGlobal.h"
// #include "PVRTContext.h"
// #include "PVRTMatrix.h"
// #include "PVRTFixedPoint.h"
// #include "PVRTMisc.h"
// #include "PVRTPFXParser.h"
// #include "PVRTResourceFile.h"
// #include "PVRTString.h"
// #include "PVRTMisc.h"		// Used for POT functions

/****************************************************************************
** Constants
****************************************************************************/
const  c_pszLinear   = "LINEAR";
const  c_pszNearest  = "NEAREST";
const  c_pszNone	  = "NONE";
const  c_pszClamp    = "CLAMP";
const  c_pszRepeat	  = "REPEAT";
const  c_pszCurrentView = "PFX_CURRENTVIEW";


const OGL_RGBA_4444 = 0x10; 
const OGL_RGBA_5551 = 0x11; 
const OGL_RGBA_8888 = 0x12; 
const OGL_RGB_565 = 0x13; 
const OGL_RGB_555 = 0x14; 
const OGL_RGB_888 = 0x15; 
const OGL_I_8 = 0x16; 


export const ETexturFilter = {
   eFilter_Nearest : 0,
   eFilter_Linear : 1,
   eFilter_None : 2,
   eFilter_Size : 3,
   eFilter_Default  :1 ,
   eFilter_MipDefault : 2
   
}

export const ETextureWrap={
  eWrap_Clamp : 0,
  eWrap_Repeat : 1,
  eWrap_Size : 2,
  eWrap_Default : 1
}


const  c_ppszFilters = //[eFilter_Size] = 
[
	c_pszNearest,		// eFilter_Nearest
	c_pszLinear,		// eFilter_Linear
	c_pszNone,			// eFilter_None
];
const  c_ppszWraps = 
[
	c_pszClamp,			// eWrap_Clamp
	c_pszRepeat			// eWrap_Repeat
];

const NEWLINE_TOKENS  = "\r\n"
const DELIM_TOKENS  = " \t"

const DEFAULT_EFFECT_NUM_TEX	=	100
const DEFAULT_EFFECT_NUM_UNIFORM	 = 100
const DEFAULT_EFFECT_NUM_ATTRIB	= 100

/****************************************************************************
** Data tables
****************************************************************************/



const _ASSERT = function(a){
    if (!a)console.error (a , "fails");
}

const PVR_FAIL = false;
const PVR_SUCCESS = true;



let  strtokLocal = "";
const strtok = function(str, others, p){
		
	if (str !== null)  strtokLocal = str;
    if (strtokLocal.length === 0) return null;
	let array = [];
   if (typeof others === 'object') array = array.concat(others);
   else{
    if (typeof others === 'string') array.push(others);
    if (typeof p === 'string') array.push(p);}
	let find = -1;
	let findwords = "";
	for (let x of array)
	{ let start = strtokLocal.indexOf(x)  ;
	  if (start > 0 &&  find > start) {find = start ; findwords = x;   }
      else if (find < 0 && start >= 0) {find = start ;  findwords = x; }
	}
		if (find === -1) {
		let result = strtokLocal;
		strtokLocal = "";
        return result;}
        
   
    let result = strtokLocal.slice(0, find);



 
    strtokLocal = strtokLocal.slice((find+findwords.length));

	return result;
}


// let strtokLocal = "";
// const strtok = function(str, others){
//     if (str !== null)  strtokLocal = str;
//     if (strtokLocal.length === 0) return null;
//     let find = strtokLocal.indexOf(others);
//     if (find === -1) {
//         let result = strtokLocal;
//         strtokLocal = "";
//         return result;}
//     let result = strtokLocal.slice(0, find);
//     strtokLocal = strtokLocal.slice((find+others.length));
//     return result;
// }

export const ESemanticDefaultDataType = 
{
	eDataTypeMat2: 0,
	eDataTypeMat3: 1,
	eDataTypeMat4: 2,
	eDataTypeVec2: 3,
	eDataTypeVec3: 4,
	eDataTypeVec4: 5,
	eDataTypeIvec2: 6,
	eDataTypeIvec3: 7,
	eDataTypeIvec4:8,
	eDataTypeBvec2:9,
	eDataTypeBvec3:10,
	eDataTypeBvec4:11,
	eDataTypeFloat:12,
	eDataTypeInt:13,
	eDataTypeBool:14,

	eNumDefaultDataTypes:15,
	eDataTypeNone:16,

	// Conceptual data types
	eDataTypeRGB:17,
	eDataTypeRGBA:18,
};

/*!*************************************************************************
@Enum   EDefaultDataInternalType
@Brief  Enum values for defining whether a variable is float, interger or bool
****************************************************************************/
const EDefaultDataInternalType = 
{
	eFloating : 0,
	eInteger : 1,
	eBoolean : 2
};

/*!*************************************************************************
@enum	EPVRTPFXPassType
@Brief  Decribes the type of render required
****************************************************************************/
const EPVRTPFXPassType =
{
	enull_PASS : 0,
	eCAMERA_PASS : 1,
	ePOSTPROCESS_PASS: 2,
	eENVMAPCUBE_PASS: 3,
	eENVMAPSPH_PASS : 4
};

/*!*************************************************************************
@enum	EPVRTPFXPassType
@Brief  Decribes the type of render required
****************************************************************************/
const EPVRTPFXPassView =
{
	eVIEW_CURRENT : 0,			// The scene's active camera is used
	eVIEW_POD_CAMERA: 1,		// The specified camera is used
	eVIEW_NONE : 2				// No specified view
};

/****************************************************************************
** Structures
****************************************************************************/
/*!*************************************************************************
@Struct SPVRTPFXParserHeader
@Brief  Struct for storing PFX file header data
****************************************************************************/
const SPVRTPFXParserHeader = function()
{
				this.version = "";
			this.description = "";
		this.copyright = "";
};

/*!*************************************************************************
@Struct SPVRTPFXParserTexture
@Brief  Struct for storing PFX data from the texture block
****************************************************************************/
const  SPVRTPFXParserTexture = function()
{
		this.name = "";  //CPVRTStringHash
	this.fileName = "";
	this.bRenderToTexture = false;
        this.nMin = 0;
         this.nMag=0;
          this.nMIP = 0;
        this.nWrapS =0;
         this.nWrapT = 0;
          this.nWrapR  = 0;	// either GL_CLAMP or GL_REPEAT //	unsigned int
            this.uiWidth =0;
             this.uiHeight = 0;  //	unsigned int
	  this.uiFlags  =0 ; //	unsigned int
};

/*!*************************************************************************
@Struct SPVRTPFXParserEffectTexture
@Brief  Stores effect texture information
****************************************************************************/
const SPVRTPFXParserEffectTexture = function()
{
	this.name = "";				// Name of texture.
	this.nNumber = 0;	//unsigned int		// Texture number to set
};

/*!*************************************************************************
@Struct SPVRTPFXParserShader
@Brief  Struct for storing PFX data from the shader block
****************************************************************************/
const SPVRTPFXParserShader = function(rhs)
{
    if(rhs){
        this.name = rhs.name;

	this.pszGLSLfile = rhs.pszGLSLfile;
	this.pszGLSLBinaryFile= rhs.pszGLSLBinaryFile;
	this.pszGLSLcode= rhs.pszGLSLcode;
	this.pbGLSLBinary= rhs.pbGLSLBinary;

	this.bUseFileName	= rhs.bUseFileName;
	this.nGLSLBinarySize = rhs.nGLSLBinarySize;
	this.nFirstLineNumber= rhs.nFirstLineNumber;
    }
    else{
	this.name = "";  //CPVRTStringHash
	this.bUseFileName = false;
	this.pszGLSLfile  ="";  //char*					
	this.pszGLSLBinaryFile = "";  //char*					
	this.pszGLSLcode = "";  //char*					
	this.pbGLSLBinary  =""; //char*					
	this.nGLSLBinarySize = 0;  //	unsigned int	
    this.nFirstLineNumber = 0;	//	unsigned int	 // Line number in the text file where this code began; use to correct line-numbers in compiler errors
    }
	// SPVRTPFXParserShader();
	// ~SPVRTPFXParserShader();
	// SPVRTPFXParserShader(const SPVRTPFXParserShader& rhs);
	// SPVRTPFXParserShader& operator=(const SPVRTPFXParserShader& rhs);



};

/*!*************************************************************************
@Struct SPVRTSemanticDefaultDataTypeInfo
@Brief  Struct for storing default data types
****************************************************************************/
const SPVRTSemanticDefaultDataTypeInfo = function(a,b,c,d)
{
        this.eType = 0;  //ESemanticDefaultDataType
        if(a) this.eType =a;
            this.pszName = "";  // 
            if(b) this.pszName = b;
        this.nNumberDataItems = 0; 
        if(c)  this.nNumberDataItems = c;//unsigned int			
this.eInternalType= 0; 
if (d) this.eInternalType = d ;//	EDefaultDataInternalType	
};

/*!*************************************************************************
@Struct SPVRTSemanticDefaultData
@Brief  Stores a default value
****************************************************************************/
const SPVRTSemanticDefaultData = function(rhs)
{
    if (rhs){
        this.pfData = rhs.pfData; //float
        this.pnData = rhs.pnData; // [4]; int
        this.pbData = rhs.pbData; //bool
        this.eType = rhs.eType;
    }
    else{
			this.pfData =  new Float32Array(16); //float
			this.pnData = new Int32Array(4); // [4]; int
			this.pbData = new Array(4); //bool
		    this.eType = ESemanticDefaultDataType.eDataTypeNone;
    }

};

/*!*************************************************************************
@Struct SPVRTPFXParserSemantic
@Brief  Stores semantic information
****************************************************************************/
const SPVRTPFXParserSemantic = function(rhs)
{
    if(rhs){
    this.pszName = rhs.pszName;
    this.pszValue = rhs.pszValue;
    this.nIdx			= rhs.nIdx;
    this.sDefaultValue   = rhs.sDefaultValue;
    }
    else{
	this.pszName = "";				/*!< The variable name as used in the shader-language code */
	this.pszValue = "";				/*!< For example: LIGHTPOSITION */
	this.nIdx = 0;				//unsigned int					/*!< Index; for example two semantics might be LIGHTPOSITION0 and LIGHTPOSITION1 */
	this.sDefaultValue = new SPVRTSemanticDefaultData()		/*!< Default value */
    }
    
};


/*!*************************************************************************
@Struct SPVRTPFXParserEffect
@Brief  Stores effect information
****************************************************************************/
const SPVRTPFXParserEffect = function()
{
							this.name = "";  //CPVRTStringHash	
									this.annotation = "";  //CPVRTString	

								this.vertexShaderName = ""; //CPVRTStringHash
								this.fragmentShaderName = ""; //CPVRTStringHash

	this.uniforms =   []; //new Array(DEFAULT_EFFECT_NUM_UNIFORM);  //	CPVRTArray<SPVRTPFXParserSemantic>	
			this.attributes = []; //new Array(DEFAULT_EFFECT_NUM_ATTRIB);
		this.textures =  [];//new Array(DEFAULT_EFFECT_NUM_TEX);
		this.targets = [];

    // SPVRTPFXParserEffect( 
    
};


/*!*************************************************************************
@Struct SPVRTPFXRenderPass
@Brief  Stores render pass information
****************************************************************************/
const SPVRTPFXRenderPass = function()
{
			this.eRenderPassType = EPVRTPFXPassType.enull_PASS	;		// Type of pass. EPVRTPFXPassType
    		this.eViewType = EPVRTPFXPassView.eVIEW_NONE;			// View type.EPVRTPFXPassView	
			this.uiFormatFlags = 0;				// Surface Type.PVRTuint32		
	    	this.pEffect = null;					// Matched pass. Needed but determined from effect block. //SPVRTPFXParserEffect*
        	this.pTexture = null;					// The RTT target for this pass. //	SPVRTPFXParserTexture*
			this.nodeName = "";					// POD Camera name. CPVRTString		
			this.semanticName = "";				// Name of this pass. CPVRTString		
	
            // eRenderPassType(),
            // eViewType(),
            // uiFormatFlags(0),
            // pEffect(null),
            // pTexture(null)
};

/*!*************************************************************************
@Struct SPVRTTargetPair
@Brief  Stores a buffer type and name for a render target.
****************************************************************************/
const SPVRTTargetPair = function()
{
					this.bufferType = ""; //CPVRTString
					this.targetName = "";  //CPVRTString
};


/****************************************************************************
** Constants
****************************************************************************/
const  PVRPFXTEX_COLOUR = 1<<30;  //PVRTuint32
const  PVRPFXTEX_DEPTH  = 1<<31;  //PVRTuint32

const   c_psSemanticDefaultDataTypeInfo =  //SPVRTSemanticDefaultDataTypeInfo
[
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeMat2,		"mat2",			4,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeMat3,		"mat3",			9,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeMat4,		"mat4",			16,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeVec2,		"vec2",			2,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeVec3,		"vec3",			3,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeVec4,		"vec4",			4,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeIvec2,		"ivec2",		2,		EDefaultDataInternalType.eInteger ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeIvec3,		"ivec3",		3,		EDefaultDataInternalType.eInteger ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeIvec4,		"ivec4",		4,		EDefaultDataInternalType.eInteger ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeBvec2,		"bvec2",		2,		EDefaultDataInternalType.eBoolean ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeBvec3,		"bvec3",		3,		EDefaultDataInternalType.eBoolean ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeBvec4,		"bvec4",		4,		EDefaultDataInternalType.eBoolean ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeFloat,		"float",		1,		EDefaultDataInternalType.eFloating ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeInt,		"int",			1,		EDefaultDataInternalType.eInteger ),
	new SPVRTSemanticDefaultDataTypeInfo( ESemanticDefaultDataType.eDataTypeBool,		"bool",			1,		EDefaultDataInternalType.eBoolean ),
];


/****************************************************************************
** PVRPFXParserReadContext Class
****************************************************************************/
function PVRPFXParserReadContext()
{
    this.nNumLines   = 0;  //unsigned int
    this.nMaxLines = 5000;
	this.ppszEffectFile = new Array(this.nMaxLines);
	this.pnFileLineNumber = new Uint32Array(this.nMaxLines);
    	
  
}






const  PVRHash = function(rhs, dataSize, dataCount){

    let m_uiHash = null;
    
    if (dataSize){
        m_uiHash = PVRHash.MakeHash(rhs, dataSize, dataCount);
    }
    else if (rhs.m_uiHash)m_uiHash = rhs.m_uiHash;
    else if (rhs.length){
        m_uiHash = PVRHash.MakeHash(rhs);
    }
    
	// /*!***************************************************************************
	// @Function		operator unsigned int
	// @Return			int	
	// @Description	Converts to unsigned int.
	// *****************************************************************************/
	// operator unsigned int() const
	// {
	// 	return m_uiHash;
	// }

	/*!***************************************************************************
	@Function		MakeHash
	@Input			String
	@Return			unsigned int			The hash.
	@Description	Generates a hash from a CPVRTString.
	// *****************************************************************************/
	// PVRHash.MakeHash(String, )
	// {


		

	// 	return PVRHash();
	// }

	/*!***************************************************************************
	@Function		MakeHash
	@Input			c_pszString
	@Return			unsigned int			The hash.
	@Description	Generates a hash from a null terminated char array.
	*****************************************************************************/
	// static CPVRTHash MakeHash(const char* c_pszString)
	// {
	// 	_ASSERT(c_pszString);

	// 	if(c_pszString[0] == 0)
	// 		return CPVRTHash();

	// 	const char* pCursor = c_pszString;
	// 	while(*pCursor) pCursor++;
	// 	return MakeHash(c_pszString, sizeof(char), (unsigned int) (pCursor - c_pszString));
	// }
		
	/*!***************************************************************************
	@Function		MakeHash
	@Input			pData
	@Input			dataSize
	@Input			dataCount
	@Return			unsigned int			The hash.
	@Description	Generates a hash from generic data. This function uses the
					32-bit Fowler/Noll/Vo algorithm which trades efficiency for
					slightly increased risk of collisions. This algorithm is
					public domain. More information can be found at:
					http://www.isthe.com/chongo/tech/comp/fnv/.
	*****************************************************************************/
    //static CPVRTHash MakeHash(const void* pData, unsigned int dataSize, unsigned int dataCount)
    PVRHash.MakeHash = function (pData, dataSize, dataCount)
	{
        if(  !dataSize  &&   String.length > 0) return PVRHash.MakeHash(String, 1,  String.length);

		_ASSERT(pData);
		_ASSERT(dataSize > 0);
        const  FNV_PRIME	 =	16777619
        const  FNV_OFFSETBIAS = 	2166136261

		if(dataCount === 0) return PVRHash();

		let  pvrHash = PVRHash();
		let p =  new Uint8Array(pData.buffer);   //(unsigned char*)  
		pvrHash.m_uiHash = FNV_OFFSETBIAS;
		for(let i = 0; i < dataSize * dataCount; ++i)
		{
			pvrHash.m_uiHash = (pvrHash.m_uiHash * FNV_PRIME) ^ p[i];
		}
		return pvrHash;
	}

			/// The hashed data.
};





/******************************************************************************

 @File         PVRTSkipGraph.h

 @Title        PVRTSkipGraph

 @Version       @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     ANSI compatible

 @Description  A "tree-like" structure for storing data which, unlike a tree, can
               reference any other node.

******************************************************************************/


	
function SPVRTHashElement(hash, data)
{	
    this.m_hash = null;
if (hash) this.m_hash = new PVRHash(hash);
this.m_skipGraphNode = null;
if(data) this.m_skipGraphNode = new PVRSkipGraphNode(data);
    


    SPVRTHashElement.prototype.getHash = function() 			//CPVRTHash&	
    { 
        return this.m_hash;
    }

    /*!***************************************************************************
    @Function		GetNode
    @Return			CPVRTSkipGraphNode<T>&	
    @Description	Return the node associated with this element.
    *****************************************************************************/
    SPVRTHashElement.prototype.getNode = function()			
    {
        return this.m_skipGraphNode; 
    }

}

function  PVRSkipGraphNode(data)
{

    let		m_pData = null;
    if (data) m_pData = data;
	let m_apDependencies = [];	// What I depend on //CPVRTArray<CPVRTSkipGraphNode*> 
	let m_apDependents = [];	  // What depends on me //CPVRTArray<CPVRTSkipGraphNode*>
    
	/*!***************************************************************************
	@Function		GetNumDependencies
	@Return			unsigned int	
	@Description	Returns the number of dependencies referenced by this node.
	*****************************************************************************/
	PVRSkipGraphNode.prototype.getNumDependencies = function() //unsigned int			
	{ 
		return m_apDependencies.length; 
	}

	/*!***************************************************************************
	@Function		GetDependency
	@Input			ui32Id
	@Return			CPVRTSkipGraphNode &	
	@Description	Returns given dependency.
	*****************************************************************************/
    PVRSkipGraphNode.prototype.getDependency = function(ui32Id)   //CPVRTSkipGraphNode& 
	{ 
		_ASSERT(ui32Id >= 0 && ui32Id < m_apDependencies.length);
		return m_apDependencies[ui32Id];
	}


	/*!***************************************************************************
	@Function		AddDependency
	@Output			pDependentNode
	@Return			bool	
	@Description	Adds a dependency to this node.
	*****************************************************************************/
	//PVRSkipGraphNode.prototype.addDependency(CPVRTSkipGraphNode* pDependentNode)
    PVRSkipGraphNode.prototype.addDependency = function(pDependentNode)
    {
		let  ui = 0;

		if(pDependentNode === this)
			return false;

		if(!pDependentNode)
			return false;

		/*
			Check the dependency doesn't already exist
		*/
		for(ui = 0; ui <m_apDependencies.length; ++ui)
		{
			if(m_apDependencies[ui] === pDependentNode)
			{
				return true;
			}
		}

		/*
			Add the dependency and also set this node as a dependent of
			the referenced node
		*/
		m_apDependencies.push(pDependentNode);
		pDependentNode.addDependent(this);
		
		return true;
	}

	/*!***************************************************************************
	@Function		GetData
	@Return			T &	
	@Description	Returns the data associated with this node.
	*****************************************************************************/
    PVRSkipGraphNode.prototype.getData = function()				
	{
		return m_pData;
	}


	/*!***************************************************************************
	@Function		AddDependent
	@Output			pDependancyNode
	@Return			bool	
	@Description	Adds a dependent to this node.
	*****************************************************************************/
	//PVRSkipGraphNode.prototype.addDependent(CPVRTSkipGraphNode* pDependencyNode)
    PVRSkipGraphNode.prototype.addDependent= function(pDependencyNode)
    {
		let ui = 0;

		if(!pDependencyNode)
			return false;

		/*
			Check the dependency doesn't already exist
		*/
		for(ui = 0; ui < m_apDependents.length; ++ui)
		{
			if(m_apDependencies[ui] === pDependencyNode)
			{
				return true;
			}
		}

		/*
			Add the dependancy
		*/
		alert("pDependencyNode");
		m_apDependents.push(pDependencyNode);
		return true;
	}

}

  const  PVRSkipGraphRoot = function() {
	
	let	m_aHashTable = []; //CPVRTArray<SPVRTHashElement>	



    const  FindNode = function ( Hash, data, T)
	{
        if(data){
            let  inputHash =    PVRHash (data, T, 1);	// Generate hash for searching
            return FindNode(inputHash);
        }
    
        let i = 0;
		let  i32HashTableSize = m_aHashTable.length;

		/*
			A NULL hash means the node has not initialised
			correctly
		*/
		if(Hash === null)
			return null;

		/*
			NOTE:
			In the future, the hash table could be sorted from
			lowest hash value to highest so that binary search could
			be used to find a given node. It should be possible to
			use a bool (or some other mechanism) to toggle this form of search
			(if the skip graph is small, it might be faster to just use a brute
			force for loop to search through)
		*/
		for(i = 0; i < i32HashTableSize; i++)
		{
			if(m_aHashTable[i].getHash() === Hash)
			{
				return m_aHashTable[i].getNode();
			}
		}

		/*
			The element wasn't found, so return null
		*/
		return null;
	}




                  
    const  RecursiveSortedListAdd = function (aOutputArray,
        currentNode)
{
let ui = 0;

/*
Recursively add dependancies first
*/
for(ui = 0; ui < currentNode.getNumDependencies(); ++ui)
{
RecursiveSortedListAdd(aOutputArray, currentNode.getDependency(ui));
}

/*
Then add this node to the array
*/
aOutputArray.push(currentNode.getData());
}

/*!***************************************************************************
@Function			GetNodeData
@Input/Output		ui32NodeID						The node's ID
@Return			T*								A handle to node's data
@Description		Retrieve a handle to the specified node's data
*****************************************************************************/
PVRSkipGraphRoot.prototype.getNodeData = function (ui32NodeID)
{
_ASSERT(ui32NodeID >= 0 && ui32NodeID < m_aHashTable.length);
return m_aHashTable[ui32NodeID].getNode().getData();
}




//-------------------------------------------------------------------------//

	/*!***************************************************************************
	 @Function			AddNode
	 @Input				data							The data of the node to be added
	 @Return			CPVRTSkipGraphNode<T>* const	A handle to the added node
	 @Description		Searches through the hash table to see if the added node already
						exists. If it doesn't, it creates a node.
						The function returns true if the node was found or was created
						successfully.
	*****************************************************************************/
PVRSkipGraphRoot.prototype.addNode = function(data, Tsize)
	{
		
		let  NewNodeHash   = PVRHash(data, Tsize, 1); //CPVRTHash
		let  iArrayElement = -1;
		/*
			First, search the hash table to see
			if the node already exists
		*/
	let skipGraphNode = FindNode(NewNodeHash); //	CPVRTSkipGraphNode<T>* 

		if(skipGraphNode === null)
		{
			/*
				The node wasn't found, so a new node needs to be
				created
            */
            iArrayElement =  m_aHashTable.length;
		    m_aHashTable.push(new SPVRTHashElement(NewNodeHash, data));

			/*
				Now point to the new instance
			*/
			skipGraphNode = m_aHashTable[iArrayElement].getNode();
		}

		return skipGraphNode ? true : false;
	}


	/*!***************************************************************************
	@Function		AddNodeDependancy
	@Input			nodeData
	@Input			dependantData
	@Return			bool	
	@Description	Adds a node dependency.
	*****************************************************************************/
	//bool AddNodeDependency(const T& nodeData, const T& dependantData)
    PVRSkipGraphRoot.prototype.addNodeDependency= function( nodeData, dependantData)
    {
		 let  pNode = null ;//(NULL);  //CPVRTSkipGraphNode<T>*
		let  pDependantNode = null ;//(NULL);  //CPVRTSkipGraphNode<T>* 

		pNode = FindNode(null, nodeData);
		if(pNode === null)
		{
			return false;
		}

		pDependantNode = FindNode(null, dependantData);
		if(pDependantNode === null)
		{
			return false;
		}

		/*
			Nodes are not allowed to self reference
		*/
		if(pNode === pDependantNode)
		{
			return false;
		}
		pNode.addDependency(pDependantNode);

		return true;
	}

	/*!***************************************************************************
	 @Function			GetNumNodes
	 @Return			unsigned int					The total number of nodes
	 @Description		Returns the total number of nodes in the skip graph.
	*****************************************************************************/
	PVRSkipGraphRoot.prototype.getNumNodes = function() 
	{
		return m_aHashTable.length;
	}

	/*!***************************************************************************
	 @Function			RetreiveSortedDependancyList
	 @Input				aOutputArray					The dynamic array to store
														the sorted results in
	 @Input				ui32NodeID						The ID of the root node for
														the dependency search
	 @Description		Returns a sorted list of dependencies for the specified
						node. The list is ordered with the leaf nodes at the front,
						followed by nodes that depend on them and so forth until
						the root node is reached and added at the end of the list
	*****************************************************************************/
	//void retreiveSortedDependencyList(CPVRTArray<T> &aOutputArray, 
                                        //const unsigned int ui32NodeID)
PVRSkipGraphRoot.prototype.retreiveSortedDependencyList= function(aOutputArray,  ui32NodeID)
	{
		_ASSERT(ui32NodeID >= 0 && ui32NodeID < m_aHashTable.length);
		RecursiveSortedListAdd(aOutputArray, m_aHashTable[ui32NodeID].getNode());
	}

}



/*!*************************************************************************
@Class PVRPFXParser
@Brief PFX parser
****************************************************************************/
const PVRPFXParser = function()
{

    PVRPFXParser.VIEWPORT_SIZE = 0xAAAA;  //unsigned int
	// NOTE: Temp hardcode viewport size
	let m_uiViewportWidth = 640;
    let m_uiViewportHeight = 480;

    //PVRPFXParser.VIEWPORT_SIZE  = 0 ;  //static const unsigned int	

   	// this.m_sHeader = new  SPVRTPFXParserHeader();

	// 	this.m_psTexture = [];  // CPVRTArrayManagedPointers<SPVRTPFXParserTexture>
	// 			this.m_psFragmentShader = []// CPVRTArray<SPVRTPFXParserShader>	;
	// 			this.m_psVertexShader = [];  //	CPVRTArray<SPVRTPFXParserShader>
	// 			this.m_psEffect  = []; 	//CPVRTArray<SPVRTPFXParserEffect>
	// 			this.m_RenderPasses  =[]; //CPVRTArray<SPVRTPFXRenderPass>	

		
	// 			this.m_psContext = new	PVRPFXParserReadContext();		
	// 			this.m_aszPostProcessNames = [];  //CPVRTArray<CPVRTString>	
	
	// 			// m_uiViewportWidth = 0;  //unsigned int	
	// 			//	let m_uiViewportHeight  = 0;// unsigned int	
	// 	this.m_renderPassSkipGraph = new PVRSkipGraphRoot();  //CPVRTSkipGraphRoot<SPVRTPFXRenderPass*>		

	


/*!**************************************************************************
 @Function			PVRPFXParserReadContext
 @Description		Initialises values.
*****************************************************************************/


/*!**************************************************************************
 @Function			IgnoreWhitespace
 @Input				pszString
 @Output			pszString
 @Description		Skips space, tab, new-line and return characters.
*****************************************************************************/
const ignoreWhitespace = function(pszString)
{
	while(	pszString[0] === '\t' ||
			pszString[0] === '\n' ||
			pszString[0] === '\r' ||
			pszString[0] === ' ' )
	{
		pszString = pszString.slice(1);
    }
    return pszString;
}

/*!**************************************************************************
 @Function			ReadEOLToken
 @Input				pToken
 @Output			char*
 @Description		Reads next strings to the end of the line and interperts as
					a token.
*****************************************************************************/
 const readEOLToken = function( pToken) // char*
{
	let pReturn = null;

    let szDelim = ['\n', 0];
    				// try newline
	pReturn = strtok(pToken, szDelim);			
    
    if(pReturn === null)
	{
		szDelim[0] = '\r';
		pReturn = strtok (pToken, szDelim);		// try linefeed
	}
	return pReturn;
}

/*!**************************************************************************
 @Function			GetSemanticDataFromString
 @Output			pDataItem
 @Modified			pszArgumentString
 @Input				eType
 @Output			pError				error message
 @Return			true if successful
 @Description		Extracts the semantic data from the string and stores it
					in the output SPVRTSemanticDefaultData parameter.
*****************************************************************************/
//const  GetSemanticDataFromString = function(SPVRTSemanticDefaultData *pDataItem, const char * const pszArgumentString, ESemanticDefaultDataType eType, CPVRTString *pError)
const  getSemanticDataFromString = function( pDataItem,  pszArgumentString,  eType)

{
	let pszString = pszArgumentString;
	let pszTmp = "";

	pszString = ignoreWhitespace(pszString);

	if(pszString[0] !== '(')
	{
		console.log("Missing '(' after " + c_psSemanticDefaultDataTypeInfo[eType].pszName);
		return false;
	}
	pszString++;

	pszString = ignoreWhitespace(pszString);

	if(pszString.length === 0 )
	{
		console.log(c_psSemanticDefaultDataTypeInfo[eType].pszName + " missing arguments");
		return false;
	}

	pszTmp = pszString;
	switch(c_psSemanticDefaultDataTypeInfo[eType].eInternalType)
	{
		case EDefaultDataInternalType.eFloating:
			pDataItem.pfData[0] = parseFloat(pszString, pszTmp);//(float)strtod(pszString, pszTmp);
			break;
		case EDefaultDataInternalType.eInteger:
			pDataItem.pnData[0] =  parseInt(pszString, pszTmp , 10);//  (int)strtol(pszString, pszTmp, 10);
			break;
		case EDefaultDataInternalType.eBoolean:
			if(pszString === "true")//if(strncmp(pszString, "true" === 0)
			{
				pDataItem.pbData[0] = true;
				pszTmp = pszString.slice(4);
			}
			else if (pszString === "false")  // (strncmp(pszString, "false", 5) === 0)
			{
				pDataItem.pbData[0] = false;
				pszTmp = pszString.slice(5);
			}
            break;
      default: break;
	}

	if(pszString === pszTmp)
	{
		// let  n = strcspn(pszString, ",\t ");
		// char *pszError = (char *)malloc(n + 1);
		// strcpy(pszError, "");
		// strncat(pszError, pszString, n);
		// *pError = CPVRTString("'") + pszError + "' unexpected for " + c_psSemanticDefaultDataTypeInfo[eType].pszName;
		console.log(" unexpected for " + c_psSemanticDefaultDataTypeInfo[eType].pszName);
		return false;
	}
	pszString = pszTmp;

    pszString =	ignoreWhitespace(pszString);

	for(let i = 1; i < c_psSemanticDefaultDataTypeInfo[eType].nNumberDataItems; i++)
	{
		if(pszString.length === 0)
		{
			console.error(c_psSemanticDefaultDataTypeInfo[eType].pszName + " missing arguments");
			return false;
		}

		if(pszString[0] !== ',')
		{
			console.error( "unexpected for " + c_psSemanticDefaultDataTypeInfo[eType].pszName);
		
			return false;
		}
		pszString++;

		pszString = ignoreWhitespace(pszString);

		if(pszString.length === 0 )
		{
            console.error( c_psSemanticDefaultDataTypeInfo[eType].pszName + " missing arguments");
			return false;
		}

		pszTmp = pszString;
		switch(c_psSemanticDefaultDataTypeInfo[eType].eInternalType)
		{
			case EDefaultDataInternalType.eFloating:
				pDataItem.pfData[i] =  parseFloat(pszString)  ;//(float)strtod(pszString, pszTmp);
				break;
			case EDefaultDataInternalType.eInteger:
				pDataItem.pnData[i] =  parseInt(pszString, 10) ; //(int)strtol(pszString, pszTmp, 10);
				break;
			case EDefaultDataInternalType.eBoolean:
				if( pszString === "true")
				{
					pDataItem.pbData[i] = true;
					pszTmp = pszString[4];
				}
				else if (pszString === "false")
				{
					pDataItem.pbData[i] = false;
					pszTmp = pszString[5];
				}
                break;
            default: break;
		}

		if(pszString === pszTmp)
		{
			// let n = strcspn(pszString, ",\t ");
			// char *pszError = (char *)malloc(n + 1);
			// strcpy(pszError, "");
			// strncat(pszError, pszString, n);
			// *pError = CPVRTString("'") + pszError + "' unexpected for " + c_psSemanticDefaultDataTypeInfo[eType].pszName;
            console.log(" unexpected for " + c_psSemanticDefaultDataTypeInfo[eType].pszName);
            //FREE(pszError);
			return false;
		}
		pszString = pszTmp;

		pszString = ignoreWhitespace(pszString);
	}

	if(pszString[0] !== ')')
	{
		// size_t n = strcspn(pszString, "\t )");
		// char *pszError = (char *)malloc(n + 1);
		// strcpy(pszError, "");
		// strncat(pszError, pszString, n);
		// *pError = CPVRTString("'") + pszError + "' found when expecting ')' for " + c_psSemanticDefaultDataTypeInfo[eType].pszName;
        // FREE(pszError);
        console.log( " found when expecting ')' for " + c_psSemanticDefaultDataTypeInfo[eType].pszName);
		return false;
	}
	pszString++;

	pszString = ignoreWhitespace(pszString);

	if(pszString.length !== 0)
	{
        //*pError = CPVRTString("'") + pszString + "' unexpected after ')'";
        console.log("'" + pszString + "' unexpected after ')'");
		return false;
	}

	return true;
}

/*!**************************************************************************
 @Function			ConcatenateLinesUntil
 @Output			pszOut		output text
 @Output			nLine		end line number
 @Input				nLine		start line number
 @Input				ppszLines	input text - one array element per line
 @Input				nLimit		number of lines input
 @Input				pszEnd		end string
 @Return			true if successful
 @Description		Outputs a block of text starting from nLine and ending
					when the string pszEnd is found.
*****************************************************************************/
//static bool ConcatenateLinesUntil(CPVRTString& Out, int &nLine, const char * const * const ppszLines, const unsigned int nLimit, const char * const pszEnd)
 //concatenateLinesUntil(CPVRTString& Out, int &nLine, const char * const * const ppszLines, const unsigned int nLimit, const char * const pszEnd)
 const concatenateLinesUntil = function(Out, nLine, ppszLines, nLimit,  pszEnd){
     let s = Out.output;
    let i =0;
    let  j = 0; //unsigned int
	let 		nLen = 0;


	for(i = nLine.i; i < nLimit; ++i)
	{
		if(ppszLines[i] === pszEnd)
			break;
		nLen += (ppszLines[i].length + 1);
	}
	if(i === nLimit)
	{
		return false;
	}

	if(nLen)
	{
		++nLen;

		//s.reserve(nLen);

		for(j = nLine.i; j < i; ++j)
		{
			//Out.append(ppszLines[j]);
            //Out.append("\n");
            s = s + ppszLines[j] + "\n";
		}
    }
    

    nLine.i = i;
    Out.output = s;
	return true;
}

// /****************************************************************************
// ** SPVRTPFXParserEffect Struct
// ****************************************************************************/
// SPVRTPFXParserEffect::SPVRTPFXParserEffect() :  
	
// {
// }



/*!**************************************************************************
 @Function			Parse
 @Output			pReturnError	error string
 @Return			bool			true for success parsing file
 @Description		Parses a loaded PFX file.
*****************************************************************************/
PVRPFXParser.prototype.parse = function ()
{

	
	 const eCmds= 
 	{
		eCmds_Header : 0,
		eCmds_Texture : 1,
		eCmds_Target : 2,
		eCmds_Textures: 3,
		eCmds_VertexShader:4,
		eCmds_FragmentShader:5,
		eCmds_Effect:6,

		eCmds_Size:7,
	};

	const  ParserCommands =   //CPVRTHash
	[
		"[HEADER]",				// eCmds_Header
		"[TEXTURE]",			// eCmds_Texture
		"[TARGET]",				// eCmds_Target
		"[TEXTURES]",			// eCmds_Textures
		"[VERTEXSHADER]",		// eCmds_VertexShader
		"[FRAGMENTSHADER]",		// eCmds_FragmentShader
		"[EFFECT]",				// eCmds_Effect
    ];

	//PVRTCOMPILEASSERT(ParserCommands, sizeof(ParserCommands) / sizeof(ParserCommands[0]) === eCmds_Size);

    let nEndLine = {};
    nEndLine.line = 0;
    let nHeaderCounter = 0;
    let nTexturesCounter = 0;
    let i = 0;
    let j = 0;
    let k = 0;  //unsigned int

	
	// Loop through the file
	for(let nLine=0; nLine < this.m_psContext.nNumLines; nLine++)
	{
	
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[nLine])
			continue;

		//CPVRTHash Cmd(this.m_psContext.ppszEffectFile[nLine]);
       
        let Cmd = this.m_psContext.ppszEffectFile[nLine];
		
		

        if(Cmd === ParserCommands[eCmds.eCmds_Header])
		{
			if(nHeaderCounter>0)
			{
				console.log("[HEADER] redefined on line %d\n" + this.m_psContext.pnFileLineNumber[nLine]);
				return false;
            }
           
			if(this.getEndTag("HEADER", nLine, nEndLine))
			{
				if(this.parseHeader(nLine, nEndLine.line)) nHeaderCounter++;
				else return false;
			}
			else
			{
				 console.log("Missing [/HEADER] tag after [HEADER] on line %d\n" + this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_Texture])
		{
			if(this.getEndTag("TEXTURE", nLine, nEndLine))
			{

				if(!this.parseTexture(nLine, nEndLine.line))
					return false;
			}
			else
			{
				console.log("Missing [/TEXTURE] tag after [TEXTURE] on line %d\n"+ this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_Target])
		{
			if(this.getEndTag("TARGET", nLine, nEndLine))
			{
				if(!this.parseTarget(nLine, nEndLine.line))
					return false;
			}
			else
			{
				 console.error("Missing [/TARGET] tag after [TARGET] on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_Textures])
		{
			if(nTexturesCounter>0)
			{
				 console.error("[TEXTURES] redefined on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			if(this.getEndTag("TEXTURES", nLine, nEndLine))
			{
				if(this.parseTextures(nLine, nEndLine.line))
					nTexturesCounter++;
				else
					return false;
			}
			else
			{
				 console.error("Missing [/TEXTURES] tag after [TEXTURES] on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_VertexShader])
		{

			if(this.getEndTag("VERTEXSHADER", nLine, nEndLine))
			{
               
				let VertexShader = new SPVRTPFXParserShader();
				if(this.parseShader(nLine, nEndLine.line, VertexShader, "VERTEXSHADER"))
					this.m_psVertexShader.push(VertexShader);
				else
					return false;
			}
			else
			{
				 console.error("Missing [/VERTEXSHADER] tag after [VERTEXSHADER] on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_FragmentShader])
		{
			if(this.getEndTag("FRAGMENTSHADER", nLine, nEndLine))
			{
                
				let FragShader  = new SPVRTPFXParserShader()
				if(this.parseShader(nLine, nEndLine.line, FragShader, "FRAGMENTSHADER"))
					this.m_psFragmentShader.push(FragShader);
				else
					return false;
			}
			else
			{
				 console.error("Missing [/FRAGMENTSHADER] tag after [FRAGMENTSHADER] on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else if(Cmd === ParserCommands[eCmds.eCmds_Effect])
		{
			if(this.getEndTag("EFFECT", nLine, nEndLine))
			{
				 let effect = new SPVRTPFXParserEffect()
				if(this.parseEffect(effect, nLine, nEndLine.line))

					this.m_psEffect.push(effect);
				else
					return false;
			}
			else
			{
				 console.error("Missing [/EFFECT] tag after [EFFECT] on line %d\n", this.m_psContext.pnFileLineNumber[nLine]);
				return false;
			}
			nLine = nEndLine.line;
		}
		else
		{
			 console.error("'%s' unexpected on line %d\n", this.m_psContext.ppszEffectFile[nLine], this.m_psContext.pnFileLineNumber[nLine]);
			return false;
		}
	}

	if(this.m_psEffect.length < 1)
	{
		 console.error("No [EFFECT] found. PFX file must have at least one defined.\n");
		return false;
	}

	if(this.m_psFragmentShader.length < 1)
	{
		 console.error("No [FRAGMENTSHADER] found. PFX file must have at least one defined.\n");;
		return false;
	}

	if(this.m_psVertexShader.length < 1)
	{
		 console.error("No [VERTEXSHADER] found. PFX file must have at least one defined.\n");
		return false;
	}

	// Loop Effects
	for(i = 0; i < this.m_psEffect.length; ++i)
	{
		// Loop Textures in Effects
		for(j = 0; j < this.m_psEffect[i].textures.length; ++j)
		{
			// Loop Textures in whole PFX
			let uiTexSize = this.m_psTexture.length;  //unsigned int
			for(k = 0; k < uiTexSize; ++k)
			{
				if(this.m_psTexture[k].name === this.m_psEffect[i].textures[j].name)
					break;
			}

			// Texture mismatch. Report error.
			if(!uiTexSize || k === uiTexSize)
			{
				console.log( "Error: TEXTURE '" + this.m_psEffect[i].textures[j].name + "' is not defined in [TEXTURES].\n");
				return false;
			}
		}
	};


	
if(!this.determineRenderPassDependencies())
	{
		return false;
	}

	return true;
}

/*!**************************************************************************
 @Function			ParseFromMemory
 @Input				pszScript		PFX script
 @Output			pReturnError	error string
 @Return			EPVRTError		PVR_SUCCESS for success parsing file
									PVR_FAIL if file doesn't exist or is invalid
 @Description		Parses a PFX script from memory.
*****************************************************************************/
 //PVRPFXParser.prototype.ParseFromMemory(const char * const pszScript, CPVRTString * const pReturnError)
 PVRPFXParser.prototype.parseFromMemory = function (stream , gl, demo, parser,  callback)//pszScript)
{
	let	context = new PVRPFXParserReadContext() 
	let pszLine  = "" //[512];
    //let 		pszEnd = "";
    let pszCurr  = "";
	let	nLineCounter = 0;
	let nLen  = 0;  //unsigned int
   let	nReduce = 0 ;  //unsigned int
	let	bDone = false;

	// if(!pszScript)
	// 	return false;
    let count = stream.GetSize();
    let totalCount = 0;

	parser.m_psContext = context;

	// Find  process each line
	nLineCounter	= 0;
	bDone			= false;
	//pszCurr			= pszScript;
	while(!bDone)
	{
        pszCurr = "";

        nLineCounter++;
        if (++totalCount > count) break;
        let temp  =  stream.ReadString(1); 
        
		while(temp === '\r') {    
            pszCurr += temp;
            if (++totalCount > count) break;
            temp  =  stream.ReadString(1);
            
        }
       
       

        nLen = 0
        while(temp !== '\n') {  
            nLen++;  
            pszCurr += temp;
            if (++totalCount > count) break;
            temp  =  stream.ReadString(1);
		}
		//if(this.m_psContext.nNumLines > 690){console.log(this.m_psContext.nNumLines, pszCurr);}
      // pszCurr += temp;
        //if(this.m_psContext.nNumLines > 690){console.log(this.m_psContext.nNumLines, pszCurr);}
        // Find length of line
        nLen =  pszCurr.length ; //indexOf('\n');
       if (nLen === 0){
			nLen = pszCurr.length;  //(unsigned int)
			bDone = true;
       }
	
	   
    //    else{
	// 	pszEnd = strchr(pszCurr, '\n');
	// 	if(pszEnd)
	// 	{
	// 		nLen = pszEnd - pszCurr;  //(unsigned int)
	// 	}
	
		

		nReduce = 0; // Tells how far to go back because of '\r'.
		while(nLen - nReduce > 0 && pszCurr[nLen - 1 - nReduce] === '\r')
			nReduce++;

		// Ensure pszLine will not be not overrun
		if (nLen+1-nReduce > 512)   // sizeof(pszLine) / sizeof(*pszLine))
	 	nLen = 512 - 1 + nReduce ; //sizeof(pszLine) / sizeof(*pszLine) - 1 + nReduce;

		// Copy line into pszLine
       // strncpy(pszLine, pszCurr, nLen - nReduce);
        pszLine = pszCurr.slice(0, nLen - nReduce);
        pszCurr = pszCurr.slice (nLen+1);
		//pszLine[nLen - nReduce] = 0;
		//pszCurr += nLen + 1;

	//	_ASSERT(pszLine.indexOf('\r') === -1);
	//	_ASSERT(pszLine.indexOf('\n') === -1);

        // Ignore comments
      
        if  (pszLine.indexOf("//") != -1)   pszLine = "";
          //  (/\/\//gi, '\0');
      
        //let tmp = strstr(pszLine, "//");

		//if(tmp !== -1)	tmp = '\0';

        // Reduce whitespace to one character.
     // if(this.m_psContext.nNumLines > 690){console.log(this.m_psContext.nNumLines, pszLine);}
        pszLine =	parser.reduceWhitespace(pszLine);
        
		// Store the line, even if blank lines (to get correct errors from GLSL compiler).
		if(parser.m_psContext.nNumLines < parser.m_psContext.nMaxLines)
		{
			parser.m_psContext.pnFileLineNumber[parser.m_psContext.nNumLines] = nLineCounter;
			//parser.m_psContext.ppszEffectFile[parser.m_psContext.nNumLines] = (char *)malloc((strlen(pszLine) + 1) * sizeof(char));
			//strcpy(parser.m_psContext.ppszEffectFile[parser.m_psContext.nNumLines], pszLine);
            parser.m_psContext.ppszEffectFile[parser.m_psContext.nNumLines] =  pszLine;
            parser.m_psContext.nNumLines++;
		}
		else
		{
			 console.error("Too many lines of text in file (maximum is $(parser.m_psContext.nMaxLines))\n");
			return PVR_FAIL;
        }
     
	}

	let result = parser.parse() ? PVR_SUCCESS : PVR_FAIL;
	if(typeof callback == "function")
    {
		//let args = [gl, textureID, pvrHeader, pvrMetaData];
		let args = [gl, demo];
        args = args.concat(Array.prototype.slice.call(arguments, 3));
      
        callback.apply(null, args);
	}
	return result;
}

/*!**************************************************************************
 @Function			ParseFromFile
 @Input				pszFileName		PFX file name
 @Output			pReturnError	error string
 @Return			EPVRTError		PVR_SUCCESS for success parsing file
									PVR_FAIL if file doesn't exist or is invalid
 @Description		Reads the PFX file and calls the parser.
*****************************************************************************/
//EPVRTError PVRPFXParser.prototype.ParseFromFile(const char * const pszFileName, CPVRTString * const pReturnError)
 PVRPFXParser.prototype.parseFromFile = function(gl, demo, pszFileName, callback)
 {




	this.m_sHeader = new  SPVRTPFXParserHeader();

	this.m_psTexture = [];  // CPVRTArrayManagedPointers<SPVRTPFXParserTexture>
			this.m_psFragmentShader = []// CPVRTArray<SPVRTPFXParserShader>	;
			this.m_psVertexShader = [];  //	CPVRTArray<SPVRTPFXParserShader>
			this.m_psEffect  = []; 	//CPVRTArray<SPVRTPFXParserEffect>
			this.m_RenderPasses  =[]; //CPVRTArray<SPVRTPFXRenderPass>	

	
			this.m_psContext = new	PVRPFXParserReadContext();		

			this.m_aszPostProcessNames = [];  //CPVRTArray<CPVRTString>	

			// m_uiViewportWidth = 0;  //unsigned int	
			//	let m_uiViewportHeight  = 0;// unsigned int	
	this.m_renderPassSkipGraph = new PVRSkipGraphRoot();  //CPVRTSkipGraphRoot<SPVRTPFXRenderPass*>		




	//  let PfxFile =new  CPVRTResourceFile(pszFileName);  //CPVRTResourceFile
	// if (!PfxFile.IsOpen())
	// {
	// 	 console.error("Unable to open file ") + pszFileName;
	// 	return PVR_FAIL;
    // }
    let PfxFile = new PVRFileStream();
    this.m_szFileName = pszFileName;
    let args = [pszFileName, true, this.parseFromMemory , gl, demo, this, callback];
    args = args.concat(Array.prototype.slice.call(arguments, 4));
    PfxFile.Open.apply(PfxFile, args);
 }

	//  let PfxFileString = ""; //CPVRTString
	//  let pPfxData = PfxFile.DataPtr();  // (const char*)

	// // Is our shader resource file data null terminated?
	// if(pPfxData[PfxFile.Size()-1] !== '\0')
	// {
	// 	// If not create a temporary null-terminated string
	// 	PfxFileString.assign(pPfxData, PfxFile.Size());
	// 	pPfxData = PfxFileString.c_str();
	// }

	//  = pszFileName; //m_szFileName.assign(pszFileName);
 
	// return this.parseFromMemory(pPfxData);



/*!**************************************************************************
 @Function			SetViewportSize
 @Input				uiWidth				New viewport width
 @Input				uiHeight			New viewport height
 @Return			bool				True on success
 @Description		Allows the current viewport size to be set. This value
					is used for calculating relative texture resolutions
*****************************************************************************/
 PVRPFXParser.prototype.setViewportSize = function(uiWidth,  uiHeight){
//bool PVRPFXParser.prototype.SetViewportSize(unsigned int uiWidth, unsigned int uiHeight)

	if(uiWidth > 0 && uiHeight > 0)
	{
		m_uiViewportWidth = uiWidth;
		m_uiViewportHeight = uiHeight;
		return true;
	}
	else
	{
		return false;
	}
}
/*!**************************************************************************
@Function		RetrieveRenderPassDependencies
@Output			aRequiredRenderPasses
@Output			aszActiveEffectStrings
@Return			bool	
@Description	Returns a list of dependencies associated with the pass.
*****************************************************************************/
 //PVRPFXParser.prototype.RetrieveRenderPassDependencies(CPVRTArray<SPVRTPFXRenderPass*> &aRequiredRenderPasses, CPVRTArray<CPVRTStringHash> &aszActiveEffectStrings)
 PVRPFXParser.prototype.retrieveRenderPassDependencies = function( aRequiredRenderPasses, aszActiveEffectStrings)
 {
 
    let  ui =0 ;
    let  uj =0 ;
    let uk = 0; 
    let ul = 0;
	let  pTempEffect = null; //SPVRTPFXParserEffect
	
	if(aRequiredRenderPasses.length > 0)
	{
		/* aRequiredRenderPasses should be empty when it is passed in */
		return false;
	}

	for(ui = 0; ui < aszActiveEffectStrings.length; ++ui) //(unsigned int)
	{
		if(aszActiveEffectStrings[ui] === ""  )
		{
			// Empty strings are not valid
			return false;
		}

		// Find the specified effect
		for(uj = 0, pTempEffect = null; uj < this.m_psEffect.length; ++uj) //(unsigned int)
		{
			if(aszActiveEffectStrings[ui] === this.m_psEffect[uj].name)
			{
				// Effect found
				pTempEffect = this.m_psEffect[uj];
				break;
			}
		}

		if(pTempEffect === null)
		{
			// Effect not found
			return false;
		}
		
		for(uj = 0; uj < this.m_renderPassSkipGraph.getNumNodes(); ++uj)
		{
			if(this.m_renderPassSkipGraph.getNodeData(uj).pEffect === pTempEffect)
			{
				this.m_renderPassSkipGraph.retreiveSortedDependencyList(aRequiredRenderPasses, uj);
				return true;
			}
		}

		/*
			The effect wasn't a post-process. Check to see if it has any non-post-process dependencies,
			e.g. RENDER CAMERA textures.
		*/
		// Loop Effects
		for(uj = 0; uj < this.m_psEffect.length; ++uj)   //(unsigned int)
		{
			if(aszActiveEffectStrings[ui] !== this.m_psEffect[uj].name)
				continue;

			// Loop Textures in Effect
			for(uk = 0; uk < this.m_psEffect[uj].textures.length;++uk)
			{
				// Loop Render Passes for whole PFX
				for(ul = 0; ul < this.m_RenderPasses.length; ++ul)
				{
					// Check that the name of this render pass output texture matches a provided texture in an Effect
					if(this.m_RenderPasses[ul].pTexture.name === this.m_psEffect[uj].textures[uk].name)
						aRequiredRenderPasses.push(this.m_RenderPasses[ul]);
				}
			}
			
			return true;
		}
	}

	return false;
}
/*!**************************************************************************
 @Function			GetEndTag
 @Input				pszTagName		tag name
 @Input				nStartLine		start line
 @Output			pnEndLine		line end tag found
 @Return			true if tag found
 @Description		Searches for end tag pszTagName from line nStartLine.
					Returns true and outputs the line number of the end tag if
					found, otherwise returning false.
*****************************************************************************/
//PVRPFXParser.prototype.getEndTag  = function (const char* pszTagName, int nStartLine, int *pnEndLine)
PVRPFXParser.prototype.getEndTag  = function (  pszTagName,  nStartLine,  pnEndLine)
{
	// char pszEndTag[100];
	// strcpy(pszEndTag, "[/");
	// strcat(pszEndTag, pszTagName);
    // strcat(pszEndTag, "]");
    
    let pszEndTag = "[/" + pszTagName + "]";

	for(let i = nStartLine; i < this.m_psContext.nNumLines; i++)
	{
		if( pszEndTag === this.m_psContext.ppszEffectFile[i])
		{
			pnEndLine.line = i;
			return true;
		}
	}

	return false;
}

/*!**************************************************************************
 @Function			ReduceWhitespace
 @Output			line		output text
 @Input				line		input text
 @Description		Reduces all white space characters in the string to one
					blank space.
*****************************************************************************/
 //PVRPFXParser.prototype.reduceWhitespace(char *line)
 PVRPFXParser.prototype.reduceWhitespace= function(line)
{
    // convert tabs and newlines to ' '
   
  let  line1 =  line.replace(/\t/gi, ' ');
  let   line2 = line1.replace(/\n/gi, ' ');
   line1 = line2.replace(/(\s)+/gi, ' ');
  
  
    // let tmp = strpbrk(line, "\t\n");
	// while(tmp !== null)
	// {
	// 	let tmp = ' ';
	// 	tmp = strpbrk (line, "\t\n");
    // }
    line1 = line1.trim();
   
    return line1; 


	// remove all whitespace at start
	while(line1[0] === ' ')
	{
		// move chars along to omit whitespace
		let counter = 0;
		do{
			line1[counter] = line1[counter+1];
			counter++;
		}while(line1[counter] !== '\0');
	}
//console.log("line1", line1);

	// step through chars of line remove multiple whitespace
	for(let i=0; i < line1.length; i++)
	{
		// whitespace found
		if(line1[i] === ' ')
		{
			// count number of whitespace chars
			let numWhiteChars = 0; //int
			while(line1[i+1+numWhiteChars] === ' ')
			{
				numWhiteChars++;
			}

			// multiple whitespace chars found
			if(numWhiteChars>0)
			{
				// move chars along to omit whitespace
				let counter = 1; //int
				while(line1[i+counter] !== '\0')
				{
					line1[i+counter] = line1[i+numWhiteChars+counter];
					counter++;
				}
			}
		}
	}
    console.log( "line2", line1);
	// If there is no string then do not remove terminating white symbols
	if(line1.length === 0)
	    return "";

	// // remove all whitespace from end
	// while(line[line.length-1] === ' ')
	// {
	// 	// move chars along to omit whitespace
	// 	line[line.length-1] = '\0';
    // }

    
    console.log( "line3", line1);
    return line1;

}

/*!**************************************************************************
 @Function			FindParameter
 @Output
 @Input
 @Description		Finds the parameter after the specified delimiting character and
					returns the parameter as a string. An empty string is returned
					if a parameter cannot be found

*****************************************************************************/
//CPVRTString PVRPFXParser.prototype.FindParameter(char *aszSourceString, const CPVRTString &parameterTag, const CPVRTString &delimiter)

 PVRPFXParser.prototype.findParameter = function(aszSourceString, parameterTag, delimiter){
    
    let returnString = "";// CPVRTString returnString = ("");
	let aszTagStart = aszSourceString.indexOf(parameterTag);

	// Tag was found, so search for parameter
	if(aszTagStart !== -1)
	{
        let aszTagStartStr = aszSourceString.slice(aszTagStart);

		let aszDelimiterStart = aszTagStartStr.indexOf( delimiter);
        
        let aszSpaceStart = aszTagStartStr.indexOf(" ");

		// Delimiter found
		if(aszDelimiterStart !== -1 && (aszSpaceStart  === -1 ||(aszDelimiterStart < aszSpaceStart)))
		{
            // Create a string from the delimiter to the next space
            let aszDelimiterStartstr =  aszTagStartStr.slice(aszDelimiterStart);
            let strCount = aszDelimiterStartstr.indexOf(" ");
			aszDelimiterStart++;	// Skip =
			returnString= aszDelimiterStartstr.slice(1, strCount-1);
		}
	}

	return returnString;
}

/*!**************************************************************************
@Function		ReadStringToken
@Input			pszSource			Parameter string to process
@Output			output				Processed string
@Output			ErrorStr			String containing errors
@Return								Returns true on success
@Description	Processes the null terminated char array as if it's a
				formatted string array. Quote marks are determined to be
				start and end of strings. If no quote marks are found the
				string is delimited by whitespace.
*****************************************************************************/
//bool PVRPFXParser.prototype.ReadStringToken(char* pszSource, CPVRTString& output, CPVRTString &ErrorStr, int i, const char* pCaller)
 PVRPFXParser.prototype.readStringToken = function( pszSourceString,  outputString,  i,  pCaller){

    
    let pszSource = pszSourceString.input;
    let output = outputString.output;
    let index = 0
	if(pszSource[index] === '"')		// Quote marks. Continue parsing until end mark or null
	{	
		index++;		// Skip past first quote
		while(pszSource[index] !== '"')
		{
			if(index >= pszSource.length)
			{
				console.error("Incomplete argument in [%s] on line %d: %s\n", pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				return false;
			}

			output.push(pszSource[index]);
			index++;
		}
		index++;		// Skip past final quote.
	}
	else		// No quotes. Read until space
	{
		let pszSource1 = strtok(pszSource, DELIM_TOKENS, NEWLINE_TOKENS);
        
        output = pszSource1;

        index += pszSource1.length;
       
    }
    
    pszSource = pszSource.slice(index);
	// Check that there's nothing left on this line
	let pszSource1 = strtok(pszSource, NEWLINE_TOKENS);
	if(pszSource1 !== null)
	{
		console.error("Unknown keyword '%s' in [%s] on line %d: %s\n", pszSource, pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
		return false;
	}
    
	return true;
}

/*!**************************************************************************
 @Function			ParseHeader
 @Input				nStartLine		start line number
 @Input				nEndLine		end line number
 @Output			pReturnError	error string
 @Return			bool			true if parse is successful
 @Description		Parses the HEADER section of the PFX file.
*****************************************************************************/
// PVRPFXParser.prototype.parseHeader = function (int nStartLine, int nEndLine, CPVRTString * const pReturnError)
PVRPFXParser.prototype.parseHeader = function ( nStartLine, nEndLine)
{
    
	 const eCmds=
	{
		eCmds_Version : 0,
		eCmds_Description:1,
		eCmds_Copyright:2,

		eCmds_Size:3,
	};

	const  HeaderCommands =
	[
		"VERSION",			// eCmds_Version
		"DESCRIPTION",		// eCmds_Description
		"COPYRIGHT",		// eCmds_Copyright
    ];
	//PVRTCOMPILEASSERT(HeaderCommands, sizeof(HeaderCommands) / sizeof(HeaderCommands[0]) === eCmds.eCmds_Size);

	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

		let str = strtok (this.m_psContext.ppszEffectFile[i]," ");
		if(str !== null)
		{
			let Cmd = str;//CPVRTHash Cmd(str);
			if(Cmd === HeaderCommands[eCmds.eCmds_Version])
			{
				str += (str.length+1); // Stream.Read(str.length);
				this.m_sHeader.Version = str; // Stream.ReadString();
			}
			else if(Cmd === HeaderCommands[eCmds.eCmds_Description])
			{
				str += (str.length+1);
				this.m_sHeader.Description = str;
			}
			else if(Cmd === HeaderCommands[eCmds.eCmds_Copyright])
			{
				str += (str.length+1);
				this.m_sHeader.Copyright = str;
			}
			else
			{
				 console.error("Unknown keyword '%s' in [HEADER] on line %d\n", str, this.m_psContext.pnFileLineNumber[i]);
				return false;
			}
		}
		else
		{
			 console.error("Missing arguments in [HEADER] on line %d : %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
			return false;
		}
	}

	return true;
}

/*!**************************************************************************
@Function			ParseGenericSurface
@Input				nStartLine		start line number
@Input				nEndLine		end line number
@Output				uiWrapS			
@Output				uiWrapT			
@Output				uiWrapR			
@Output				uiMin			
@Output				uiMag			
@Output				uiMip			
@Output				pReturnError	error string
@Return				bool			true if parse is successful
@Description		Parses generic data from TARGET and TEXTURE blocks. Namely
					wrapping and filter commands.
*****************************************************************************/
//PVRPFXParser.prototype.ParseGenericSurface(int nStartLine, int nEndLine, SPVRTPFXParserTexture& Params, CPVRTArray<CPVRTHash>& knownCmds, 
                                     //    const char* pCaller, CPVRTString * const pReturnError)
PVRPFXParser.prototype.parseGenericSurface = function( nStartLine,  nEndLine,  Params, knownCmds, 
                                             pCaller)                                        
{
	const  INVALID_TYPE = 0xAC1DBEEF;  //unsigned int
	
	 const eCmds= 
	{
		eCmds_Min : 0,
		eCmds_Mag: 1,
		eCmds_Mip:2,
		eCmds_WrapS : 3,
		eCmds_WrapT:4,
		eCmds_WrapR:5,
		eCmds_Filter:6,
		eCmds_Wrap:7,
		eCmds_Resolution:8,
		eCmds_Surface:9,

		eCmds_Size:10
    };

	const  GenericSurfCommands =
	[
		"MINIFICATION",			// eCmds_Min
		"MAGNIFICATION",		// eCmds_Mag
		"MIPMAP",				// eCmds_Mip
		"WRAP_S",				// eCmds_WrapS
		"WRAP_T",				// eCmds_WrapT
		"WRAP_R",				// eCmds_WrapR
		"FILTER",				// eCmds_Filter
		"WRAP",					// eCmds_Wrap
		"RESOLUTION",			// eCmds_Resolution
		"SURFACETYPE",			// eCmds_Surface
    ];
//	PVRTCOMPILEASSERT(GenericSurfCommands, sizeof(GenericSurfCommands) / sizeof(GenericSurfCommands[0]) === eCmds_Size);

	function SSurfacePair(a,b,c)
	{
        this.name = "";
        if(a) this.name = a;
        this.eType = 0 ;  //PVRTPixelType
        if(b) this.eType = b;
        this.bufferType = 0; // unsigned int
        if(c)   this.bufferType = c
	};

	const  SurfacePairs =  //SSurfacePair
	[
		new SSurfacePair( "RGBA8888",	OGL_RGBA_8888,	PVRPFXTEX_COLOUR ),
		new SSurfacePair( "RGBA4444",	OGL_RGBA_4444,	PVRPFXTEX_COLOUR ),
		new SSurfacePair( "RGB888",		OGL_RGB_888,	PVRPFXTEX_COLOUR ),
		new SSurfacePair( "RGB565",		OGL_RGB_565,	PVRPFXTEX_COLOUR ),		
		new SSurfacePair( "INTENSITY8",	OGL_I_8,		PVRPFXTEX_COLOUR ),
		new SSurfacePair( "DEPTH24",	OGL_RGB_888,	PVRPFXTEX_DEPTH ),
		new SSurfacePair( "DEPTH16",	OGL_RGB_565,	PVRPFXTEX_DEPTH ),
		new SSurfacePair( "DEPTH8",		OGL_I_8,		PVRPFXTEX_DEPTH ),
    ];
	const  uiNumSurfTypes = SurfacePairs.length; // sizeof(SurfacePairs) / sizeof(SurfacePairs[0]);  //unsigned int

	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

		// Need to make a copy so we can use strtok and not affect subsequent parsing
		//let lineLen = this.m_psContext.ppszEffectFile[i].length;
		//let pBlockCopy = new char[lineLen+1];
		//strcpy(
       let  pBlockCopy=  this.m_psContext.ppszEffectFile[i] ; //);

		let str = strtok (pBlockCopy, NEWLINE_TOKENS, DELIM_TOKENS);
		if(str === null)
		{
			 pBlockCopy = null;
			return false;		
		}

		let Cmd = str;  //CPVRTHash
		let ppFilters  = null;
		let bKnown = false;

		// --- Verbose filtering flags
		if(Cmd === GenericSurfCommands[eCmds.eCmds_Min] || Cmd === GenericSurfCommands[eCmds.eCmds_Mag] || Cmd === GenericSurfCommands[eCmds.eCmds_Mip])
		{
			ppFilters = c_ppszFilters;
			bKnown     = true;
		}
		// --- Verbose wrapping flags
		else if(Cmd === GenericSurfCommands[eCmds.eCmds_WrapS] || Cmd === GenericSurfCommands[eCmds.eCmds_WrapT] || Cmd === GenericSurfCommands[eCmds.eCmds_WrapR])
		{
			ppFilters = c_ppszWraps;
			bKnown     = true;
		}
		// --- Inline filtering flags
		else if(Cmd === GenericSurfCommands[eCmds.eCmds_Filter])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS, DELIM_TOKENS);
			if(pszRemaining === null)
			{
				 console.error("Missing FILTER arguments in [%s] on line %d: %s\n", pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				 pBlockCopy = null;
				return false;
			}

			let pFlags =  //unsigned int* 
			[
				Params.nMin,
				Params.nMag,
				Params.nMIP,
            ];

			if(!this.parseTextureFlags(pszRemaining, pFlags, 3, c_ppszFilters, ETexturFilter.eFilter_Size, i))
			{
				pBlockCopy = null
				return false;
			}

			bKnown     = true;
		}
		// --- Inline wrapping flags
		else if(Cmd === GenericSurfCommands[eCmds.eCmds_Wrap])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS, DELIM_TOKENS);
			if(pszRemaining === null)
			{
				 console.error("Missing WRAP arguments in [%s] on line %d: %s\n", pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				pBlockCopy = null;
				return false;
			}

			let  pFlags = // unsigend int
			[
				Params.nWrapS,
				Params.nWrapT,
				Params.nWrapR,
            ];

			if(!this.parseTextureFlags(pszRemaining, pFlags, 3, c_ppszWraps, ETextureWrap.eWrap_Size, i))
			{
				pBlockCopy = null
				return false;
			}

			bKnown     = true;
		}
		// --- Resolution
		else if(Cmd === GenericSurfCommands[eCmds.eCmds_Resolution])
		{
			let pszRemaining = "";

			let uiVals = [ Params.uiWidth, Params.uiHeight ];

			// There should be precisely TWO arguments for resolution (width and height)
			for(let uiIndex = 0; uiIndex < 2; ++uiIndex)
			{
				pszRemaining = strtok(null, DELIM_TOKENS, NEWLINE_TOKENS);
				if(pszRemaining === null)
				{
					console.error("Missing RESOLUTION argument(s) (requires width AND height) in [TARGET] on line %d\n", this.m_psContext.pnFileLineNumber[i]);
					pBlockCopy = null;
					return false;
				}

				let val = parseInt(pszRemaining, 10);//atoi(pszRemaining); //int

				if( (val === 0 && pszRemaining !== '0')			// Make sure they haven't explicitly set the value to be 0 as this might be a valid use-case.
					||  (val < 0))
				{
					 console.error("Invalid RESOLUTION argument \"%s\" in [TEXTURE] on line %d\n", pszRemaining, this.m_psContext.pnFileLineNumber[i]);
					pBlockCopy = null;
					return false;
				}

				uiVals[uiIndex] = val;  //(unsigned int)
			}

			bKnown     = true;
		}
		// --- Surface type
		else if(Cmd === GenericSurfCommands[eCmds.eCmds_Surface])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS, DELIM_TOKENS); //char*
			if(pszRemaining === null)
			{
				 console.error("Missing SURFACETYPE arguments in [TARGET] on line %d\n", this.m_psContext.pnFileLineNumber[i]);
				 pBlockCopy = null;
				return false;
			}

			let  hashType = pszRemaining; //CPVRTHash hashType(pszRemaining);
			for(let uiIndex = 0; uiIndex < uiNumSurfTypes; ++uiIndex)
			{
				if(hashType === SurfacePairs[uiIndex].name)
				{
					Params.uiFlags =  SurfacePairs[uiIndex].eType | SurfacePairs[uiIndex].bufferType;
					break;
				}
			}

			bKnown     = true;
		}

		// Valid Verbose command
		if(ppFilters)
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS ,DELIM_TOKENS);
			if(pszRemaining === null)
			{
				 console.error("Missing arguments in [%s] on line %d: %s\n", pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				 pBlockCopy = null;
				return false;
			}

			let type = INVALID_TYPE; //unsigned int
			for(let uiIndex = 0; uiIndex < 3; ++uiIndex)
			{
				if (pszRemaining === ppFilters[uiIndex])  //if(strcmp(pszRemaining, ppFilters[uiIndex]) === 0)	
				{
					type = uiIndex;			// Yup, it's valid.
					break;
				}
			}

			// Tell the user it's invalid.
			if(type === INVALID_TYPE)
			{
				 console.error("Unknown keyword '%s' in [%s] on line %d: %s\n", pszRemaining, pCaller, this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
				pBlockCopy= null;
				return false;
			}

			if(Cmd === GenericSurfCommands[eCmds.eCmds_Min])			Params.nMin = type;		
			else if(Cmd === GenericSurfCommands[eCmds.eCmds_Mag])		Params.nMag = type;	
			else if(Cmd === GenericSurfCommands[eCmds.eCmds_Mip])		Params.nMIP = type;	
			else if(Cmd === GenericSurfCommands[eCmds.eCmds_WrapR])	Params.nWrapR = type;	
			else if(Cmd === GenericSurfCommands[eCmds.eCmds_WrapS])	Params.nWrapS = type;	
			else if(Cmd === GenericSurfCommands[eCmds.eCmds_WrapT])	Params.nWrapT = type;
		}

		if(bKnown)
		{
			knownCmds.push(Cmd);

			// Make sure nothing else exists on the line that hasn't been parsed.
			let pszRemaining = strtok(null, NEWLINE_TOKENS);
			if(pszRemaining !== null)
			{
				 console.error("Unexpected keyword '%s' in [%s] on line %d: %s\n", pszRemaining, pCaller, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				 pBlockCopy = null;
				return false;
			}
		}	

		pBlockCopy = null;
	}

	return true;
}

/*!**************************************************************************
@Function			ParseTexture
@Input				nStartLine		start line number
@Input				nEndLine		end line number
@Output				pReturnError	error string
@Return				bool			true if parse is successful
@Description		Parses the TEXTURE section of the PFX file.
*****************************************************************************/
//PVRPFXParser.prototype.parseTexture = function(int nStartLine, int nEndLine, CPVRTString * const pReturnError)
PVRPFXParser.prototype.parseTexture = function( nStartLine,  nEndLine)
{

	 const eCmds= 
	{
		eCmds_Name: 0,
		eCmds_Path: 1,
		eCmds_View: 2,
		eCmds_Camera: 3,

		eCmds_Size:4
    };

	const  TextureCmds =
	[
		"NAME",				// eTextureCmds_Name
		"PATH",				// eTextureCmds_Path
		"VIEW",				// eTextureCmds_View
		"CAMERA",			// eTextureCmds_Camera
    ];
	//PVRTCOMPILEASSERT(TextureCmds, sizeof(TextureCmds) / sizeof(TextureCmds[0]) === eCmds.eCmds_Size);

	let TexDesc = new SPVRTPFXParserTexture();
	TexDesc.nMin = ETexturFilter.eFilter_Default;
	TexDesc.nMag = ETexturFilter.eFilter_Default;
	TexDesc.nMIP = ETexturFilter.eFilter_MipDefault;
	TexDesc.nWrapS = ETextureWrap.eWrap_Default;
	TexDesc.nWrapT = ETextureWrap.eWrap_Default;
	TexDesc.nWrapR = ETextureWrap.eWrap_Default;
	TexDesc.uiWidth  = PVRPFXParser.VIEWPORT_SIZE;
	TexDesc.uiHeight = PVRPFXParser.VIEWPORT_SIZE;
	TexDesc.uiFlags  = OGL_RGBA_8888 | PVRPFXTEX_COLOUR;

	let  knownCmds  = [] ; //CPVRTArray<CPVRTHash>
	if(!this.parseGenericSurface(nStartLine, nEndLine, TexDesc, knownCmds, "TEXTURE"))
		return false;

    let texName ="";
    let  filePath = "";
    let  viewName = "";
	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

		let str = strtok (this.m_psContext.ppszEffectFile[i], NEWLINE_TOKENS, DELIM_TOKENS);
		if(str === null)
		{
			 console.error("Missing arguments in [TEXTURE] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
			return false;
		}

		let texCmd = str;
		// --- Texture Name
		if(texCmd === TextureCmds[eCmds.eCmds_Name])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS, DELIM_TOKENS);
			if(pszRemaining === null)
			{
				 console.error("Missing NAME arguments in [TEXTURE] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				return false;
			}

			texName = pszRemaining;
		}
		// --- Texture Path
		else if(texCmd === TextureCmds[eCmds.eCmds_Path])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS);
			if(pszRemaining === null)
			{
				 console.error("Missing PATH arguments in [TEXTURE] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				return false;
			}
            let filePathString = {}
            filePathString.output = filePath;
            let  pszRemainingStr = {}
            pszRemainingStr.input = pszRemaining
			if(!this.readStringToken(pszRemainingStr, filePathString, i, "TEXTURE"))
			{
				return false;
            }
            filePath =  filePathString.output;
            pszRemaining = pszRemainingStr.input;
		}
		// --- View/Camera Name
		else if(texCmd === TextureCmds[eCmds.eCmds_View] || texCmd === TextureCmds[eCmds.eCmds_Camera])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS);		// String component. Get the rest of the line.
			if( pszRemaining === null || pszRemaining.length === 0)
			{
				 console.error("Missing VIEW argument in [TEXTURE] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
				return false;
			}

            let viewNameString = {}
            viewNameString.output = viewName
            let  pszRemainingStr = {}
            pszRemainingStr.input = pszRemaining

			if(!this.readStringToken(pszRemainingStr, viewNameString, i, "TEXTURE"))
			{
				return false;
            }
            viewName = viewNameString.output;
            pszRemaining = pszRemainingStr.input;
		}
		else if(knownCmds.includes(texCmd))
		{
			// Remove from 'unknown' list.
			for(let uiIndex = 0; uiIndex < knownCmds.length; ++uiIndex)
			{
				if(knownCmds[uiIndex] === texCmd)
				{
					knownCmds.splice(uiIndex,1);
					break;
				}
			}

			continue;		// This line has already been processed.
		}
		else
		{
			 console.error("Unknown keyword '%s' in [TEXTURE] on line %d: %s\n", str, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
			return false;
		}

		let pszRemaining = strtok(null, NEWLINE_TOKENS);
		if(pszRemaining !== null)
		{
			 console.error("Unexpected keyword '%s' in [TEXTURE] on line %d: %s\n", pszRemaining, this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
			return false;
		}
	}

	if(texName === "")
	{
		 console.error("No NAME tag specified in [TEXTURE] on line %d\n", this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}
	if(!filePath === ""   && !viewName === "")
	{
		 console.error("Both PATH and VIEW tags specified in [TEXTURE] on line %d\n", this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}
	if(filePath === ""   && viewName === "")
	{
		 console.error("No PATH or VIEW tag specified in [TEXTURE] on line %d\n", this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}

	let bRTT = (viewName === "" ? false : true);
	if(bRTT)
	{
		filePath = texName;									// RTT doesn't have a physical file.
	}

	// Create a new texture and copy over the vals.
	let pTex = new SPVRTPFXParserTexture();  //SPVRTPFXParserTexture* 
	pTex.name				= texName; //CPVRTStringHash
	pTex.fileName			= filePath;  //CPVRTStringHash
	pTex.bRenderToTexture	= bRTT;
	pTex.nMin				= TexDesc.nMin;
	pTex.nMag				= TexDesc.nMag;
	pTex.nMIP				= TexDesc.nMIP;
	pTex.nWrapS			= TexDesc.nWrapS;
	pTex.nWrapT			= TexDesc.nWrapT;
	pTex.nWrapR			= TexDesc.nWrapR;
	pTex.uiWidth			= TexDesc.uiWidth;
	pTex.uiHeight			= TexDesc.uiHeight;
	pTex.uiFlags			= TexDesc.uiFlags;
	this.m_psTexture.push(pTex);

	if(bRTT)
	{
        let  uiPassIdx = this.m_RenderPasses.length;
        this.m_RenderPasses.push(new SPVRTPFXRenderPass()); //unsigned int
		this.m_RenderPasses[uiPassIdx].SemanticName = texName;

		if(viewName === c_pszCurrentView)
		{
			this.m_RenderPasses[uiPassIdx].eViewType	 = EPVRTPFXPassView.eVIEW_CURRENT;
		}
		else
		{
			this.m_RenderPasses[uiPassIdx].eViewType	 = EPVRTPFXPassView.eVIEW_POD_CAMERA;
			this.m_RenderPasses[uiPassIdx].NodeName	 = viewName;
		}

		this.m_RenderPasses[uiPassIdx].eRenderPassType = EPVRTPFXPassType.eCAMERA_PASS;			// Textures are always 'camera' passes

		// Set render pass texture to the newly created texture.
		this.m_RenderPasses[uiPassIdx].pTexture		 = pTex;
		this.m_RenderPasses[uiPassIdx].uiFormatFlags  = TexDesc.uiFlags;
	}
	
	return true;
}

/*!**************************************************************************
@Function			ParseTarget
@Input				nStartLine		start line number
@Input				nEndLine		end line number
@Output				pReturnError	error string
@Return				bool			true if parse is successful
@Description		Parses the TARGET section of the PFX file.
*****************************************************************************/
//const PVRPFXParser.prototype.ParseTarget = function (int nStartLine, int nEndLine, CPVRTString * const pReturnError)
 PVRPFXParser.prototype.parseTarget = function ( nStartLine,  nEndLine)
{
	 const eCmds=
	{
		eCmds_Name: 0,

		eCmds_Size: 1
	};

	const  TargetCommands =
	[
		"NAME",				// eCmds_Name
    ];
	//PVRTCOMPILEASSERT(TargetCommands, sizeof(TargetCommands) / sizeof(TargetCommands[0]) === eCmds.eCmds_Size);
	
	let targetName = "" //CPVRTString
	let TexDesc = new SPVRTPFXParserTexture();
	TexDesc.nMin = ETexturFilter.eFilter_Default;
	TexDesc.nMag = ETexturFilter.eFilter_Default;
	TexDesc.nMIP = ETexturFilter.eFilter_MipDefault;
	TexDesc.nWrapS = ETextureWrap.eWrap_Default;
	TexDesc.nWrapT = ETextureWrap.eWrap_Default;
	TexDesc.nWrapR = ETextureWrap.eWrap_Default;
	TexDesc.uiWidth  = PVRPFXParser.VIEWPORT_SIZE;
	TexDesc.uiHeight = PVRPFXParser.VIEWPORT_SIZE;
	TexDesc.uiFlags  = OGL_RGBA_8888 | PVRPFXTEX_COLOUR;

	let knownCmds = [];  //CPVRTArray<CPVRTHash>
	if(!this.parseGenericSurface(nStartLine, nEndLine, TexDesc, knownCmds, "TARGET"))
		return false;
	
	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

		let str = strtok (this.m_psContext.ppszEffectFile[i], NEWLINE_TOKENS , DELIM_TOKENS);
		if(str === null)
		{
			 console.error("Missing arguments in [TARGET] on line %d\n", this.m_psContext.pnFileLineNumber[i]);
			return false;
		}

		let texCmd = str;//CPVRTHash 
		// --- Target Name
		if(texCmd === TargetCommands[eCmds.eCmds_Name])
		{
			let pszRemaining = strtok(null, NEWLINE_TOKENS , DELIM_TOKENS);
			if(pszRemaining=== null)
			{
				 console.error("Missing NAME arguments in [TARGET] on line %d\n", this.m_psContext.pnFileLineNumber[i]);
				return false;
			}

			targetName = pszRemaining;
		}
		else if(knownCmds.includes(texCmd))
		{
			// Remove from 'unknown' list.
			for(let uiIndex = 0; uiIndex < knownCmds.length; ++uiIndex)
			{
				if(knownCmds[uiIndex] === texCmd)
				{
					knownCmds.splice(uiIndex,1);
					break;
				}
			}

			continue;		// This line has already been processed.
		}
		else
		{
			 console.error("Unknown keyword '%s' in [TARGET] on line %d\n", str, this.m_psContext.pnFileLineNumber[i]);
			return false;
		}

		let pszRemaining = strtok(null, NEWLINE_TOKENS);
		if(pszRemaining !== null)
		{
			 console.error("Unexpected keyword '%s' in [TARGET] on line %d\n", pszRemaining, this.m_psContext.pnFileLineNumber[i]);
			return false;
		}
	}

	// Create a new texture and copy over the vals.
 let pTex = new SPVRTPFXParserTexture(); //	SPVRTPFXParserTexture*
	pTex.name				= targetName;//CPVRTStringHash(targetName);
	pTex.fileName			= targetName;//CPVRTStringHash(targetName);
	pTex.bRenderToTexture	= true;
	pTex.nMin				= TexDesc.nMin;
	pTex.nMag				= TexDesc.nMag;
	pTex.nMIP				= TexDesc.nMIP;
	pTex.nWrapS			    = TexDesc.nWrapS;
	pTex.nWrapT		    	= TexDesc.nWrapT;
	pTex.nWrapR			    = TexDesc.nWrapR;
	pTex.uiWidth			= TexDesc.uiWidth;
	pTex.uiHeight			= TexDesc.uiHeight;
	pTex.uiFlags			= TexDesc.uiFlags;
	this.m_psTexture.push(pTex);

	// Copy to render pass struct
let  uiPassIdx = this.m_RenderPasses.Append();
	this.m_RenderPasses[uiPassIdx].SemanticName		= targetName;
	this.m_RenderPasses[uiPassIdx].eViewType			= EPVRTPFXPassView.eVIEW_NONE;
	this.m_RenderPasses[uiPassIdx].eRenderPassType	= EPVRTPFXPassType.ePOSTPROCESS_PASS;			// Targets are always post-process passes.
	this.m_RenderPasses[uiPassIdx].pTexture			= pTex;
	this.m_RenderPasses[uiPassIdx].uiFormatFlags		= TexDesc.uiFlags;

	return true;
}

/*!**************************************************************************
 @Function			ParseTextures		** DEPRECATED **
 @Input				nStartLine		start line number
 @Input				nEndLine		end line number
 @Output			pReturnError	error string
 @Return			bool			true if parse is successful
 @Description		Parses the TEXTURE section of the PFX file.
*****************************************************************************/
// PVRPFXParser.prototype.parseTextures = function (int nStartLine, int nEndLine, CPVRTString * const pReturnError)
PVRPFXParser.prototype.parseTextures = function ( nStartLine,  nEndLine)
 {
    // char *pszName(null), *pszFile(null), *pszKeyword(null);    
	// char *pszRemaining(null), *pszTemp(null);
	// bool bReturnVal(false);

    let pszName = null;
		let		pszFile = null;
		    let    pszKeyword = null;
			let 	pszTemp = null;
             let    pszRemaining = null;
             let bReturnVal = false;
                
	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

        let str = strtok (this.m_psContext.ppszEffectFile[i]," ");
		if(str !== null)
		{
			// Set defaults
            let	uiMin = ETexturFilter.eFilter_Default;
            let uiMag = ETexturFilter.eFilter_Default;
            let  uiMip = ETexturFilter.eFilter_MipDefault;
            let	uiWrapS = ETextureWrap.eWrap_Default;
            let uiWrapT =ETextureWrap.eWrap_Default ;
            let  uiWrapR =ETextureWrap.eWrap_Default;
			let	uiFlags = 0; //unsigned int

			  let uiWidth	= PVRPFXParser.VIEWPORT_SIZE; //unsigned int
	    	let  uiHeight	= PVRPFXParser.VIEWPORT_SIZE; //	unsigned int

			// Reset variables
				pszName = null;
				pszFile = null;
		        pszKeyword = null;
				pszTemp = null;
				pszRemaining = null;

			// Compare against all valid keywords
			if(str !== "FILE"  &&  str !== "RENDER")
			{
				 console.error("Unknown keyword '%s' in [TEXTURES] on line %d\n", str, this.m_psContext.pnFileLineNumber[i]);
				bReturnVal = false;
    return bReturnVal;
			}

//#if 1
			if( str === "RENDER")
			{
				 console.error("RENDER tag no longer supported in [TEXTURES] block. Use new [TARGET] block instead\n");
				bReturnVal = false;
    return bReturnVal;
			}
//#endif

			//pszKeyword = (char *)malloc( ((int)strlen(str)+1) * sizeof(char));
			//strcpy(pszKeyword, str);
            
            pszKeyword = str;

			str = strtok (null, " ");
			if(str !== null)
			{
				//pszName = (char *)malloc( ((int)strlen(str)+1) * sizeof(char));
                //strcpy(pszName, str);
                pszName = str;

			}
			else
			{
				 console.error("Texture name missing in [TEXTURES] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
				bReturnVal = false;
    return bReturnVal;
			}

			/*
				The pszRemaining string is used to look for remaining flags.
				This has the advantage of allowing flags to be order independent
				and makes it easier to ommit some flags, but still pick up others
				(the previous method made it diffifult to retrieve filtering info
				if flags before it were missing)
			*/
			pszRemaining  = strtok(null, "\n");

			if(pszRemaining === null)
			{
				 console.error("Incomplete definition in [TEXTURES] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
				bReturnVal = false;
    return bReturnVal;
			}
			else if( pszKeyword === "FILE")
			{
				// pszTemp = (char *)malloc( ((int)strlen(pszRemaining)+1) * sizeof(char));
                // strcpy(pszTemp, pszRemaining);
                
                pszTemp = pszRemaining;

				str = strtok (pszTemp, " ");

				if(str !== null)
				{
					// pszFile = (char *)malloc( ((int)strlen(str)+1) * sizeof(char));
                    // strcpy(pszFile, str);
                    pszFile = str;
				}
				else
				{
					 console.error("Texture name missing in [TEXTURES] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
					bReturnVal = false;
                      return bReturnVal;
				}
			}

			if( pszKeyword === "FILE")
			{
                // --- Filter flags
                
				{
					let pFlags = //unsigned int* 
					[
						uiMin,
						uiMag,
						uiMip,
                    ];

					if(!this.parseTextureFlags(pszRemaining, pFlags, 3, c_ppszFilters, ETexturFilter.eFilter_Size, i))
						{bReturnVal = false;
    return bReturnVal;}
				}

				// --- Wrap flags
				{
					let  pFlags =  //unsigned int*
					[
						uiWrapS,
						uiWrapT,
						uiWrapR,
                    ];

					if(!this.parseTextureFlags(pszRemaining, pFlags, 3, c_ppszWraps, ETextureWrap.eWrap_Size, i))
						{bReturnVal = false;
    return bReturnVal;}
				}
	
				let pTex = new SPVRTPFXParserTexture(); //SPVRTPFXParserTexture* 
				pTex.name				= pszName ;//CPVRTStringHash();
				pTex.fileName			= pszFile ; //CPVRTStringHash();
				pTex.bRenderToTexture	= false;
				pTex.nMin				= uiMin;
				pTex.nMag				= uiMag;
				pTex.nMIP				= uiMip;
				pTex.nWrapS			= uiWrapS;
				pTex.nWrapT			= uiWrapT;
				pTex.nWrapR			= uiWrapR;
				pTex.uiWidth			= uiWidth;
				pTex.uiHeight			= uiHeight;
				pTex.uiFlags			= uiFlags;
				this.m_psTexture.push(pTex);
			}
			else
			{
				console.error("Unknown keyword '%s' in [TEXTURES] on line %d\n", str, this.m_psContext.pnFileLineNumber[i]);;
				bReturnVal = false;
    return bReturnVal;
			}
		}
		else
		{
			 console.error("Missing arguments in [TEXTURES] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i],  this.m_psContext.ppszEffectFile[i]);
			bReturnVal = false;
    return bReturnVal;;
		}
	}

	/*
		Should only reach here if there have been no issues
	*/
	bReturnVal = true;
    return bReturnVal;
    //goto release_return

// fail_release_return:
//     bReturnVal = false;
//     return bReturnVal;
// release_return:
// 	FREE(pszKeyword);
// 	FREE(pszName);
// 	FREE(pszFile);
// 	FREE(pszTemp);
// 	return bReturnVal;
}

/*!**************************************************************************
@Function		ParseTextureFlags
@Input			c_pszCursor
@Output			pFlagsOut
@Input			uiNumFlags
@Input			ppszFlagNames
@Input			uiNumFlagNames
@Input			pReturnError
@Input			iLineNum
@Return			bool	
@Description	Parses the texture flag sections.
*****************************************************************************/

//PVRPFXParser.prototype.parseTextureFlags = function (	const char* c_pszRemainingLine, unsigned int** ppFlagsOut, unsigned int uiNumFlags, const char** c_ppszFlagNames, unsigned int uiNumFlagNames, 
//										CPVRTString * const pReturnError, int iLineNum)
PVRPFXParser.prototype.parseTextureFlags = function (	c_pszRemainingLine,  ppFlagsOut,  uiNumFlags,  c_ppszFlagNames,  uiNumFlagNames, iLineNum)
{
	const  INVALID_TYPE = 0xAC1DBEEF;  //unsigned int
	 let uiIndex  = 0; //unsigned int
	// const char* c_pszCursor;
	// const char* c_pszResult;
	// --- Find the first flag
    //uiIndex = 0;
  
    let c_pszCursor = c_pszRemainingLine.indexOf( c_ppszFlagNames[uiIndex++]);

	while(uiIndex < uiNumFlagNames)
	{
       
        let c_pszResult = c_pszRemainingLine.indexOf( c_ppszFlagNames[uiIndex++]);
      
      

		if(((c_pszResult < c_pszCursor) || c_pszCursor === -1 ) && (c_pszResult !== -1))
            c_pszCursor = c_pszResult;
           
	}
    
	if(c_pszCursor === -1) return true;		// No error, but just return as no flags specified.

	// Quick error check - make sure that the first flag found is valid.
	if(c_pszCursor !== 0)//c_pszRemainingLine)
	{
		if( c_pszRemainingLine[c_pszCursor-1] === '-')		// Yeah this shouldn't be there. Must be invalid first tag.
		{
			let szBuffer = ""; //[128];		// Find out the tag.
			//memset(szBuffer, 0, sizeof(szBuffer));
			let pszStart = c_pszCursor-1;  //const char*
			while(pszStart !== c_pszRemainingLine && pszStart !== ' ')		pszStart--;
			pszStart++;	// Escape the space.
			let uiNumChars =  ((c_pszCursor-1) - pszStart); //(unsigned int)
		//	strncpy(szBuffer, pszStart, uiNumChars);
            szBuffer = pszStart.slice(0,uiNumChars-1);

			console.error("Unknown keyword '%s' in [TEXTURES] on line %d: %s\n", szBuffer, this.m_psContext.pnFileLineNumber[iLineNum], this.m_psContext.ppszEffectFile[iLineNum]);
			return false;
		}
	}

   let uiFlagsFound = 0;  //	unsigned int
   let uiBufferIdx = 0;  //unsigned int 
	//char szBuffer[128];		// Buffer to hold the token
    let szBuffer = "";	
  
	while(c_pszRemainingLine[c_pszCursor] !== ' ' && c_pszRemainingLine[c_pszCursor] !== '\0' && uiFlagsFound < uiNumFlags)
	{
		//memset(szBuffer, 0, sizeof(szBuffer));		// Clear the buffer
		uiBufferIdx = 0;
    
		while(c_pszRemainingLine[c_pszCursor] !== '-' && c_pszRemainingLine[c_pszCursor] !== '\0' && c_pszRemainingLine[c_pszCursor] !== ' ' && uiBufferIdx < 128)		// - = delim. token
            {szBuffer += c_pszRemainingLine[c_pszCursor++];
                uiBufferIdx ++;
            }
           // c_pszCursor = c_pszCursor.slice(1) 

		// Check if the buffer content is a valid flag name.
		let type = INVALID_TYPE; //unsigned int
		for(let uiIndex = 0; uiIndex < uiNumFlagNames; ++uiIndex)
		{
			if(szBuffer === c_ppszFlagNames[uiIndex])	
			{
				type = uiIndex;			// Yup, it's valid. uiIndex here would translate to one of the enums that matches the string array of flag names passed in.
				break;
			}
		}

		// Tell the user it's invalid.
		if(type === INVALID_TYPE)
		{
			console.error("Unknown keyword '%s' in [TEXTURES] on line %d: %s\n", szBuffer, this.m_psContext.pnFileLineNumber[iLineNum], this.m_psContext.ppszEffectFile[iLineNum]);
			return false;
		}

		// Set the flag to the enum type.
		ppFlagsOut[uiFlagsFound++] = type;

		if(c_pszCursor === '-')	c_pszCursor++;
	}

	return true;
}

/*!**************************************************************************
 @Function			ParseShader
 @Input				nStartLine		start line number
 @Input				nEndLine		end line number
 @Output			pReturnError	error string
 @Output			shader			shader data object
 @Input				pszBlockName	name of block in PFX file
 @Return			bool			true if parse is successful
 @Description		Parses the VERTEXSHADER or FRAGMENTSHADER section of the
					PFX file.
*****************************************************************************/
 //PVRPFXParser.prototype.parseShader = function(int nStartLine, int nEndLine, CPVRTString * const pReturnError, SPVRTPFXParserShader &shader, const char * const pszBlockName)
 PVRPFXParser.prototype.parseShader = function( nStartLine,  nEndLine,  shader,  pszBlockName)
 {
	 const eCmds=
	{
		eCmds_GLSLCode : 0,
		eCmds_Name: 1,
		eCmds_File: 2,
		eCmds_BinaryFile:3,
		eCmds_Size:4,
	};

	const  ShaderCommands = 
	[
		"[GLSL_CODE]",
		"NAME",
		"FILE",
		"BINARYFILE",
    ];
	//PVRTCOMPILEASSERT(ShaderCommands, sizeof(ShaderCommands) / sizeof(ShaderCommands[0]) === eCmds.eCmds_Size);

    let glslcode= false; 
    let glslfile=false; 
    let bName=false;

	shader.bUseFileName		= false;
	shader.pszGLSLfile		= null;
	shader.pszGLSLcode		= null;
	shader.pszGLSLBinaryFile= null;
	shader.pbGLSLBinary		= null;
	shader.nFirstLineNumber	= 0;

	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;
       
		 let str = strtok (this.m_psContext.ppszEffectFile[i]," ");
		if(str !== null)
		{
		let Cmd = str;  //	CPVRTHash

			// Check for [GLSL_CODE] tags first and remove those lines from loop.
			if(Cmd === ShaderCommands[eCmds.eCmds_GLSLCode])
			{
				if(glslcode)
				{
					 console.error("[GLSL_CODE] redefined in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
				if(glslfile && shader.pbGLSLBinary==null )
				{
					 console.error("[GLSL_CODE] not allowed with FILE in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				shader.nFirstLineNumber = this.m_psContext.pnFileLineNumber[i];

				// Skip the block-start
				i++;

                let GLSLCode = {}; //CPVRTString
                GLSLCode.output = "";
                let input = {};
                input.i = i;

				if(!concatenateLinesUntil(
					GLSLCode,
					input,
					this.m_psContext.ppszEffectFile,
					this.m_psContext.nNumLines,
					"[/GLSL_CODE]"))
				{
					return false;
				}

                i = input.i;
				//shader.pszGLSLcode = (char*)malloc((GLSLCode.size()+1) * sizeof(char));
				//strcpy(shader.pszGLSLcode, GLSLCode.c_str());
                shader.pszGLSLcode = GLSLCode.output;

				shader.bUseFileName = false;
				glslcode = 1;
			}
			else if(Cmd === ShaderCommands[eCmds.eCmds_Name])
			{
               
				if(bName)
				{
					 console.error("NAME redefined in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				str = readEOLToken(null);
                

				if(str === null)
				{
					 console.error("NAME missing value in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				shader.name = str; //shader.name.assign(str);
				bName = true;
			}
			else if(Cmd === ShaderCommands[eCmds.eCmds_File])
			{

                
				if(glslfile)
				{
					 console.error("FILE redefined in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
				if(glslcode)
				{
					 console.error("FILE not allowed with [GLSL_CODE] in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				str = readEOLToken(null);

				if(str === null)
				{
					 console.error("FILE missing value in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				//shader.pszGLSLfile = (char*)malloc((strlen(str)+1) * sizeof(char));
				//strcpy(shader.pszGLSLfile, str);
               
                shader.pszGLSLfile = str

				let GLSLFile = str; //CPVRTResourceFile

				if(!GLSLFile.IsOpen())
				{
					 console.error("Error loading file '%s' in [%s] on line %d\n", str, pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
                }
                
				//shader.pszGLSLcode = new char[GLSLFile.Size() + 1];
			  //	memcpy(shader.pszGLSLcode,  GLSLFile.DataPtr(), GLSLFile.Size());
				shader.pszGLSLcode   =     GLSLFile //     [GLSLFile.Size()] = '\0';

				shader.nFirstLineNumber = this.m_psContext.pnFileLineNumber[i];		// Mark position where GLSL file is defined.

				shader.bUseFileName = true;
				glslfile = 1;
			}
			else if(Cmd === ShaderCommands[eCmds.eCmds_BinaryFile])
			{
               
				str = readEOLToken(null);

				if(str === null)
				{
					 console.error("BINARYFILE missing value in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				//shader.pszGLSLBinaryFile = (char*)malloc((strlen(str)+1) * sizeof(char));
				//strcpy(shader.pszGLSLBinaryFile, str);
                
                shader.pszGLSLBinaryFile = str;

				let  GLSLFile = str; //CPVRTResourceFile

				if(!GLSLFile.IsOpen())
				{
					 console.error("Error loading file '%s' in [%s] on line %d\n", str, pszBlockName, this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
				//shader.pbGLSLBinary = new char[GLSLFile.Size()];
				//shader.nGLSLBinarySize = GLSLFile.Size(); // (unsigned int)
				//memcpy(shader.pbGLSLBinary, GLSLFile.DataPtr(), GLSLFile.Size());


                shader.pbGLSLBinary = GLSLFile;

				shader.bUseFileName = true;
				glslfile = 1;
			}
			else
			{
				 console.error("Unknown keyword '%s' in [%s] on line %d\n", str, pszBlockName, this.m_psContext.pnFileLineNumber[i]);
				return false;
			}

			str = strtok (null, " ");
			if(str !== null)
			{
				 console.error("Unexpected data in [%s] on line %d: '%s'\n", pszBlockName, this.m_psContext.pnFileLineNumber[i], str);
				return false;
			}
		}
		else
		{
         
			 console.error("Missing arguments in [%s] on line %d: %s\n", pszBlockName, this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
			return false;
		}
	}

	if(!bName)
	{
		 console.error("NAME not found in [%s] on line %d.\n", pszBlockName, this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}

	if(!glslfile && !glslcode)
	{
		 console.error("No Shader File or Shader Code specified in [%s] on line %d\n", pszBlockName, this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}

	return true;
}

/*!**************************************************************************
 @Function			ParseSemantic
 @Output			semantic		semantic data object
 @Input				nStartLine		start line number
 @Output			pReturnError	error string
 @Return			bool			true if parse is successful
 @Description		Parses a semantic.
*****************************************************************************/
//PVRPFXParser.prototype.parseSemantic = function(SPVRTPFXParserSemantic &semantic, const int nStartLine, CPVRTString * const pReturnError)
PVRPFXParser.prototype.parseSemantic = function(semantic,  nStartLine)
{
	let str = "";

	semantic.pszName = 0;
	semantic.pszValue = 0;
	semantic.sDefaultValue.eType = ESemanticDefaultDataType.eDataTypeNone;
	semantic.nIdx = 0;
    str = strtok (null, " ");

	if(str === null)
	{
		console.error("UNIFORM missing name in [EFFECT] on line %d\n" + this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}
	//semantic.pszName = (char*)malloc((strlen(str)+1) * sizeof(char));
	semantic.pszName = str;
    str = strtok (null, " ");
    
	if(str === null)
	{
		console.error("UNIFORM missing value in [EFFECT] on line %d\n" + this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}
    
	/*
		If the final digits of the semantic are a number they are
		stripped off and used as the index, with the remainder
		used as the semantic.
	*/
	{
        let idx = 0;
        let len = str.length;


		idx = len;
		while(idx)
		{
			--idx;
            //if(strcspn(str[idx]  , "0123456789") !== 0) 
			let stridx = str[idx];
			
            if( stridx[0] !== "0" && stridx[0] !== "1" && stridx[0] !== "2" &&stridx[0] !== "3" &&stridx[0] !== "4" &&
            stridx[0] !== "5" &&stridx[0] !== "6" &&stridx[0] !== "7" &&stridx[0] !== "8" &&stridx[0] !== "9" )
			{
				break;
			}
		}
		if(idx === 0)
		{
			console.error("Semantic contains only numbers in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[nStartLine]);

		//	FREE(semantic.pszName);
			return false;
		}

		++idx;
		// Store the semantic index
		if(len === idx)
		{
			semantic.nIdx = 0;
		}
		else
		{
			semantic.nIdx =  parseInt(str[idx], 10);   //atoi(&str[idx]);
		}

		// Chop off the index from the string containing the semantic
		str = str.slice(0, idx);
		
	}

	// Store a copy of the semantic name
	//semantic.pszValue = (char*)malloc((strlen(str)+1) * sizeof(char));
	//strcpy(semantic.pszValue, str);
    semantic.pszValue = str;
	/*
		Optional default semantic value
	*/
	//char pszString[2048];
    //strcpy(pszString,"");
    let  pszString = "";

	str = strtok (null, " ");
	if(str !== null)
	{
		// Get all ramainning arguments
		while(str !== null)
		{
			//strcat(pszString, str);
            //strcat(pszString, " ");
            pszString += (str + " ");
			str = strtok (null, " ");
		}

		// default value
		let i = 0 ;
		for(i = 0; i < ESemanticDefaultDataType.eNumDefaultDataTypes; i++)
		{
			//if(strncmp(pszString, c_psSemanticDefaultDataTypeInfo[i].pszName, strlen(c_psSemanticDefaultDataTypeInfo[i].pszName)) === 0)
            if(pszString === c_psSemanticDefaultDataTypeInfo[i].pszName)
			
            {
				if(!getSemanticDataFromString(	semantic.sDefaultValue,
												//pszString[strlen(c_psSemanticDefaultDataTypeInfo[i].pszName)],
                                                pszString[c_psSemanticDefaultDataTypeInfo[i].pszName.length],
                                                c_psSemanticDefaultDataTypeInfo[i].eType
												))
				{
					console.error(" on line %d.\n"+ this.m_psContext.pnFileLineNumber[nStartLine]);

				//	FREE(semantic.pszValue);
				//	FREE(semantic.pszName);
					return false;
				}

				semantic.sDefaultValue.eType = c_psSemanticDefaultDataTypeInfo[i].eType;
				break;
			}
		}

		// invalid data type
		if(i === ESemanticDefaultDataType.eNumDefaultDataTypes)
		{
			console.error("'%s' unknown on line %d.\n"+ pszString+ this.m_psContext.pnFileLineNumber[nStartLine]);

			//FREE(semantic.pszValue);
			//FREE(semantic.pszName);
			return false;
		}

	}

	return true;
}

/*!*************************************************************************
 @Function			ParseEffect
 @Output			effect			effect data object
 @Input				nStartLine		start line number
 @Input				nEndLine		end line number
 @Output			pReturnError	error string
 @Return			bool			true if parse is successful
 @Description		Parses the EFFECT section of the PFX file.
*****************************************************************************/
 //PVRPFXParser.prototype.parseEffect = function(SPVRTPFXParserEffect &effect, const int nStartLine, const int nEndLine, CPVRTString * const pReturnError)
 PVRPFXParser.prototype.parseEffect = function( effect,  nStartLine, nEndLine )
 
 {
	const eCmds = 
	{
		eCmds_Annotation: 0,
		eCmds_VertexShader: 1,
		eCmds_FragmentShader:2,
		eCmds_Texture: 3,
		eCmds_Uniform:4,
		eCmds_Attribute:5,
		eCmds_Name:6,
		eCmds_Target:7,

		eCmds_Size:8,
	};

	const  EffectCommands =  //CPVRTHash
	[
		"[ANNOTATION]",
		"VERTEXSHADER",
		"FRAGMENTSHADER",
		"TEXTURE",
		"UNIFORM",
		"ATTRIBUTE",
		"NAME",
		"TARGET",
    ];
	//PVRTCOMPILEASSERT(EffectCommands, sizeof(EffectCommands) / sizeof(EffectCommands[0]) === eCmds_Size);

	let bName = false;
	let bVertShader = false;
	let bFragShader = false;

	for(let i = nStartLine+1; i < nEndLine; i++)
	{
		// Skip blank lines
		if(!this.m_psContext.ppszEffectFile[i])
			continue;

		let str = strtok (this.m_psContext.ppszEffectFile[i]," ");
		if(str !== null)
		{
			let Cmd = str; //CPVRTHash//

			if(Cmd === EffectCommands[eCmds.eCmds_Annotation])
			{
				if(!effect.annotation === ""  )
				{
					console.log("ANNOTATION redefined in [EFFECT] on line %d: \n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

                i++;		// Skip the block-start
                

                let input = {}
                input.i = i;
                let out = {}
                out.output = effect.annotation;

				if(!concatenateLinesUntil(
					out,
					input,
					this.m_psContext.ppszEffectFile,
					this.m_psContext.nNumLines,
					"[/ANNOTATION]"))
				{
					return false;
                }
                
    i = input.i;
    effect.annotation = out.output;

			}
			else if(Cmd === EffectCommands[eCmds.eCmds_VertexShader])
			{
				if(bVertShader)
				{
					console.error("VERTEXSHADER redefined in [EFFECT] on line %d: \n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				str = readEOLToken(null);

				if(str === null)
				{
					console.error("VERTEXSHADER missing value in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
				effect.vertexShaderName = str;//	effect.vertexShaderName.assign(str);

				bVertShader = true;
			}
			else if(Cmd === EffectCommands[eCmds.eCmds_FragmentShader])
			{
				if(bFragShader)
				{
					console.error("FRAGMENTSHADER redefined in [EFFECT] on line %d: \n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				str = readEOLToken(null);

				if(str === null)
				{
					console.error("FRAGMENTSHADER missing value in [EFFECT] on line %d\n"+this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
				effect.fragmentShaderName = str;

				bFragShader = true;
			}
			else if(Cmd === EffectCommands[eCmds.eCmds_Texture])
			{

			
                let uiTexIdx = effect.textures.length;
                effect.textures.push(new SPVRTPFXParserEffectTexture());  //unsigned int
				// texture number
				str = strtok(null, " ");
			
				if(str !== null)
					effect.textures[uiTexIdx].nNumber =  parseInt(str, 10)//atoi(str);
				else
				{
					console.error("TEXTURE missing value in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}

				// texture name
				str = strtok(null, " ");

				if(str !== null)
				{
					effect.textures[uiTexIdx].name =  str;//CPVRTStringHash(str);
				}
				else
				{
					console.error("TEXTURE missing value in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[i]);
					return false;
				}
			}
			else if(Cmd === EffectCommands[eCmds.eCmds_Uniform])
			{
                let uiUniformIdx = effect.uniforms.length;
                effect.uniforms.push(new SPVRTPFXParserSemantic ()); //unsigned int
				if(!this.parseSemantic(effect.uniforms[uiUniformIdx], i))
					return false;

			}
			else if(Cmd === EffectCommands[eCmds.eCmds_Attribute])
			{
                let uiAttribIdx = effect.attributes.length;
                effect.attributes.push(new SPVRTPFXParserSemantic()); //unsigned int
				if(!this.parseSemantic(effect.attributes[uiAttribIdx], i))
					return false;
			}
			else if(Cmd === EffectCommands[eCmds.eCmds_Name])
			{
				if(bName)
				{
					console.error("NAME redefined in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[nStartLine]);
					return false;
				}

				str = strtok (null, " ");
				if(str === null)
				{
					console.error("NAME missing value in [EFFECT] on line %d\n"+ this.m_psContext.pnFileLineNumber[nStartLine]);
					return false;
				}

				effect.name = str;
				bName = true;
			}
			else if(Cmd === EffectCommands[eCmds.eCmds_Target])
			{
                let uiIndex = effect.targets.length;
                effect.targets.push( new SPVRTTargetPair() );
				// Target requires 2 components
				//let pVals = [ effect.targets[uiIndex].bufferType, effect.targets[uiIndex].targetName ];
                //CPVRTString* 
				for(let uiVal = 0; uiVal < 2; ++uiVal)
				{
					str = strtok(null, " ");
					if(str === null)
					{
						 console.error("TARGET missing value(s) in [EFFECT] on line %d\n", this.m_psContext.pnFileLineNumber[nStartLine]);
						return false;
					}
                    if (uiVal === 0){effect.targets[uiIndex].bufferType = str;}
                    else{effect.targets[uiIndex].targetName = str; }
				
				}
			}
			else
			{
				 console.error("Unknown keyword '%s' in [EFFECT] on line %d\n", str, this.m_psContext.pnFileLineNumber[i]);
				return false;
			}
		}
		else
		{
			 console.error( "Missing arguments in [EFFECT] on line %d: %s\n", this.m_psContext.pnFileLineNumber[i], this.m_psContext.ppszEffectFile[i]);
			return false;
		}
	}

	// Check that every TEXTURE has a matching UNIFORM



	for(let uiTex = 0; uiTex < effect.textures.length; ++uiTex)
	{

		

		let uiTexUnit			= effect.textures[uiTex].nNumber;
		const  texName  = effect.textures[uiTex].name;
		// Find UNIFORM associated with the TexUnit (e.g TEXTURE0).
		let bFound = false;
		for(let uiUniform = 0; uiUniform < effect.uniforms.length; ++uiUniform)
		{
			const  sem = effect.uniforms[uiUniform];  //SPVRTPFXParsersemantic&
			if( sem.pszValue === "TEXTURE" && sem.nIdx === uiTexUnit)
			{
				bFound = true;
				break;
			}
		}

		if(!bFound)
		{
			 console.error("TEXTURE %s missing matching UNIFORM in [EFFECT] on line %d\n", texName.c_str(), this.m_psContext.pnFileLineNumber[nStartLine]);
			return false;
		}
	}


	if(!bName)
	{
		 console.error("No 'NAME' found in [EFFECT] on line %d\n", this.m_psContext.pnFileLineNumber[nStartLine]);
		return false;
	}
	if(!bVertShader)
	{
		 console.error("No 'VERTEXSHADER' defined in [EFFECT] starting on line %d: \n", this.m_psContext.pnFileLineNumber[nStartLine-1]);
		return false;
	}
	if(!bFragShader)
	{
		 console.error("No 'FRAGMENTSHADER' defined in [EFFECT] starting on line %d: \n", this.m_psContext.pnFileLineNumber[nStartLine-1]);
		return false;
	}

	return true;
}

/*!*************************************************************************
 @Function			DetermineRenderPassDependencies
 @Return			True if dependency tree is valid. False if there are errors
					in the dependency tree (e.g. recursion)
 @Description		Looks through all of the effects in the .pfx and determines
					the order of render passes that have been declared with
					the RENDER tag (found in [TEXTURES]
*****************************************************************************/
// PVRPFXParser.prototype.determineRenderPassDependencies = function (CPVRTString * const pReturnError)
PVRPFXParser.prototype.determineRenderPassDependencies = function ()
{
    let ui = 0; 
    let uj = 0;
    let uk = 0; //(0), uj(0), uk(0);  //unsigned int

	if(this.m_RenderPasses.length === 0)
		return true;

	// --- Add all render pass nodes to the skip graph.
	for(ui = 0; ui < this.m_RenderPasses.length; ++ui)
	{
		let pass = this.m_RenderPasses[ui]; //SPVRTPFXRenderPass& 
		let bFound = false;

		// Search all EFFECT blocks for matching TARGET. This is for post-processes behavior.
		for(let uiEffect = 0; uiEffect < this.m_psEffect.length; ++uiEffect)
		{
			let effect = this.m_psEffect[uiEffect];  //SPVRTPFXParserEffect& 

			// Search all TARGETs in this effect
			for(let uiTargets = 0; uiTargets < effect.targets.length; ++uiTargets)
			{
				let target = effect.targets[uiTargets]; //const SPVRTTargetPair& 
				if(target.targetName === pass.semanticName)
				{
					// Match. This EFFECT block matches the pass name.
					pass.pEffect = effect;
					bFound = true;

					// This is now a post-process pass. Set relevant values.
					pass.eRenderPassType = EPVRTPFXPassType.ePOSTPROCESS_PASS;
					this.m_aszPostProcessNames.push(pass.semanticName);

					// Check that the surface type and output match are relevant (i.e DEPTH !== RGBA8888).
                    //if( (target.bufferType.indexOf("DEPTH") !== CPVRTString::npos && !(pass.uiFormatFlags & PVRPFXTEX_DEPTH))
                    if(target.bufferType.indexOf("DEPTH") !== -1 && !(pass.uiFormatFlags & PVRPFXTEX_DEPTH)){
						 console.error("Surface type mismatch in [EFFECT]. \"%s\" has different type than \"%s\"\n", target.targetName, pass.semanticName);
						return false;
					}
                   // if	(target.bufferType.indexOf("COLOR") !== CPVRTString::npos && !(pass.uiFormatFlags & PVRPFXTEX_COLOUR)) )
                    if	(target.bufferType.indexOf("COLOR") !== -1 && !(pass.uiFormatFlags & PVRPFXTEX_COLOUR)) {
                        console.error("Surface type mismatch in [EFFECT]. \"%s\" has different type than \"%s\"\n", target.targetName, pass.semanticName);
                       return false;
                   }
					break;
				}
			}

			if(bFound)
				break;
		}

		// Add a pointer to the post process
		this.m_renderPassSkipGraph.addNode(pass);
	}


	// --- Loop through all created render passes in the skip graph and determine their dependencies
	for(ui = 0; ui < this.m_renderPassSkipGraph.getNumNodes(); ++ui)
	{
		//	Loop through all other nodes in the skip graph 
	let pPass			= this.m_renderPassSkipGraph.getNodeData(ui);  //	SPVRTPFXRenderPass*
	let	pTestPass       = null; //SPVRTPFXRenderPass* 

		for(uj = 0; uj < this.m_RenderPasses.length; ++uj)
		{
			pTestPass = this.m_renderPassSkipGraph.getNodeData(uj);
				
			// No self compare
			if(pPass === pTestPass)
				continue;

			// No effect associated.
			if(!pPass.pEffect)			
				continue;

			// Is the node a render pass I rely on?
			for(uk = 0; uk < pPass.pEffect.textures.length; ++uk)
			{
				/*
					If the texture names match, add a new node
				*/
				if(pTestPass.pTexture.name === pPass.pEffect.textures[uk].name)
				{
					this.m_renderPassSkipGraph.addNodeDependency(pPass, pTestPass);
					break;
				}
			}
		}
	}
	
	return true;
}

/*!*************************************************************************
@Function		FindTextureIndex
@Input			TextureName
@Return			unsigned int	Index in to the effect.texture array.
@Description	Returns the index in to the texture array within the effect 
				block where the given texture resides.
*****************************************************************************/
//PVRPFXParser.prototype.FindTextureIndex( const CPVRTStringHash& TextureName, unsigned int uiEffect ) const
PVRPFXParser.prototype.findTextureIndex= function( textureName,  uiEffect ) 
{
	for(let uiIndex = 0; uiIndex < this.m_psEffect[uiEffect].textures.length; ++uiIndex)
	{
		let tex = this.m_psEffect[uiEffect].textures[uiIndex];
		if(tex.name === textureName)
		{
			return uiIndex;
		}
	}

	return 0xFFFFFFFF;
}

/*!*************************************************************************
@Function		GetNumberRenderPasses
@Return			unsigned int
@Description	Returns the number of render passes within this PFX.
*****************************************************************************/
//

 PVRPFXParser.prototype.getNumberRenderPasses = function() 
{
	return this.m_RenderPasses.length;
}

/*!**************************************************************************
@Function		GetNumberRenderPasses
@Input			unsigned int		The render pass index.
@Return			SPVRTPFXRenderPass*
@Description	Returns the given render pass.
*****************************************************************************/
 PVRPFXParser.prototype.getRenderPass = function(   uiIndex ) 
{
	//_ASSERT(uiIndex >= 0 && uiIndex < GetNumberRenderPasses());
	return this.m_RenderPasses[uiIndex];
}

/*!**************************************************************************
@Function		GetPFXFileName
@Return			const CPVRTString &	
@Description	Returns the PFX file name associated with this object.
*****************************************************************************/
//const CPVRTString& PVRPFXParser.prototype.GetPFXFileName() const
 PVRPFXParser.prototype.getPFXFileName= function() 
{
	return this.m_szFileName;
}

/*!**************************************************************************
@Function		GetPostProcessNames
@Return			const CPVRTArray<CPVRTString>&	
@Description	Returns a list of prost process effect names.
*****************************************************************************/
//const CPVRTArray<CPVRTString>& PVRPFXParser.prototype.GetPostProcessNames() const
PVRPFXParser.prototype.getPostProcessNames= function() 

{
	return this.m_aszPostProcessNames;
}

/*!**************************************************************************
@Function		GetNumberFragmentShaders
@Return			unsigned int	Number of fragment shaders.
@Description	Returns the number of fragment shaders referenced in the PFX.
*****************************************************************************/
//unsigned int PVRPFXParser.prototype.GetNumberFragmentShaders() const
 PVRPFXParser.prototype.getNumberFragmentShaders = function() 
{
	return this.m_psFragmentShader.length;
}


/*!**************************************************************************
@Function		GetFragmentShader
@Input			unsigned int		The index of this shader.
@Return			const SPVRTPFXParserShader&		The PFX fragment shader.
@Description	Returns a given fragment shader.
*****************************************************************************/
//SPVRTPFXParserShader& PVRPFXParser.prototype.GetFragmentShader( unsigned int uiIndex )
 PVRPFXParser.prototype.getFragmentShader = function(  uiIndex )
{
	_ASSERT(uiIndex < this.getNumberFragmentShaders());
	return this.m_psFragmentShader[uiIndex];
}

/*!**************************************************************************
@Function		GetNumberVertexShaders
@Return			unsigned int	Number of vertex shaders.
@Description	Returns the number of vertex shaders referenced in the PFX.
*****************************************************************************/
//unsigned int PVRPFXParser.prototype.GetNumberVertexShaders() 
 PVRPFXParser.prototype.getNumberVertexShaders = function() 
{
	return this.m_psVertexShader.length;
}

/*!**************************************************************************
@Function		GetVertexShader
@Input			unsigned int		The index of this shader.
@Return			const SPVRTPFXParserShader&		The PFX vertex shader.
@Description	Returns a given vertex shader.
*****************************************************************************/
//SPVRTPFXParserShader& PVRPFXParser.prototype.GetVertexShader( unsigned int uiIndex )
 PVRPFXParser.prototype.getVertexShader = function(  uiIndex )
{
	_ASSERT(uiIndex < this.getNumberVertexShaders());
	return this.m_psVertexShader[uiIndex];
}

/*!**************************************************************************
@Function		GetNumberEffects
@Return			unsigned int	Number of effects.
@Description	Returns the number of effects referenced in the PFX.
*****************************************************************************/
//unsigned int PVRPFXParser.prototype.GetNumberEffects() const
PVRPFXParser.prototype.getNumberEffects = function() 
{
	return this.m_psEffect.length;
}

/*!**************************************************************************
@Function		GetEffect
@Input			uiIndex		The index of this effect.
@Return			The PFX effect.
@Description	Returns a given effect.
*****************************************************************************/
//const SPVRTPFXParserEffect& PVRPFXParser.prototype.GetEffect(unsigned int uiIndex) const
PVRPFXParser.prototype.getEffect= function(uiIndex) 
{
	_ASSERT(uiIndex < this.getNumberEffects());

	return this.m_psEffect[uiIndex];
}

/*!**************************************************************************
@Function		GetNumberTextures
@Return			unsigned int	Number of effects.
@Description	Returns the number of textures referenced in the PFX.
*****************************************************************************/
//unsigned int PVRPFXParser.prototype.getNumberTextures() 
PVRPFXParser.prototype.getNumberTextures = function() 
{
	return this.m_psTexture.length;
}



/*!**************************************************************************
@Function		GetTexture
@Input			unsigned int		The index of this texture
@Return			const SPVRTPFXParserEffect&		The PFX texture.
@Description	Returns a given texture.
*****************************************************************************/
//const SPVRTPFXParserTexture* PVRPFXParser.prototype.getTexture( unsigned int uiIndex ) const
 PVRPFXParser.prototype.getTexture = function(  uiIndex ) 
{
	_ASSERT(uiIndex < this.getNumberTextures());
	return this.m_psTexture[uiIndex];
}

/*!**************************************************************************
@Function		FindEffectByName
@Input			Name
@Return			int	
@Description	Returns the index of the given string. Returns -1 on failure.
*****************************************************************************/
//int PVRPFXParser.prototype.FindEffectByName(const CPVRTStringHash& Name) const
 PVRPFXParser.prototype.findEffectByName = function(name) 
{
	if(name.length === 0)
		return -1;

	for(let uiIndex = 0; uiIndex < this.getNumberEffects(); ++uiIndex)
	{
		if(this.getEffect(uiIndex).name === name)
		{
			return uiIndex;
		}
	}
	
	return -1;
}

/*!**************************************************************************
@Function		FindTextureByName
@Input			Name		Name of the texture.
@Return			int	
@Description	Returns the index of the given texture. Returns -1 on failure.
*****************************************************************************/
//int PVRPFXParser.prototype.FindTextureByName(const CPVRTStringHash& Name) const
PVRPFXParser.prototype.findTextureByName = function( name) 
{
	if(name.length === 0)
		return -1;

	for(let uiIndex = 0; uiIndex < this.getNumberTextures(); ++uiIndex)
	{
		if(this.getTexture(uiIndex).name === name)
		{
			return uiIndex;
		}
	}
	return -1;
}

// /*!**************************************************************************
// @Function		PVRTPFXCreateStringCopy
// @Return			void
// @Description	Safely copies a C string.
// *****************************************************************************/
// //void PVRTPFXCreateStringCopy(char** ppDst, const char* pSrc)
//  PVRTPFXCreateStringCopy= function(ppDst,  pSrc)
// {
// 	if(pSrc)
// 	{
// 		ppDst=  pSrc
// 	}
// }

/*****************************************************************************
 End of file (PVRTPFXParser.cpp)
*****************************************************************************/

return null;

}


export default PVRPFXParser